const $bd94a79bfb1fb5b4$export$615455393ee443ca = {
    // Version is used to track the version of the save data. If the structure of the save data changes, the version number should be updated.
    // Important: Only update the version number here for breaking changes.
    version: "0.3.0",
    level: 1,
    experience: 0,
    skillPoints: 0,
    saveId: 0,
    gold: 0,
    hp: 30,
    maxHp: 30,
    mp: 5,
    maxMp: 5,
    attack: 25,
    magicAttack: 25,
    defense: 25,
    magicDefense: 25,
    combat: {
        shopCellar: {
            tilesToEnemy: 4
        }
    },
    // The dialogue object is created dynamically. It tracks the player's progress within dialogue chains.
    dialogue: {},
    canExitDialogue: false,
    // The modifiedTiles object is created dynamically. It tracks the player's progress within locations.
    modifiedTiles: {},
    modifiedNpcs: [],
    currentLocation: "elarianGates",
    hideHealth: true,
    hideMagic: true,
    inventory: [],
    x: 2,
    y: 0
};





const $b7a927103247c962$export$79f4124ce8bee305 = {
    combatKey: "shopCellar",
    enemies: [
        {
            name: "rat",
            tileImage: "rat",
            encounterDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopCellar.firstRat")) return "shopCellar.firstRat";
                return "shopCellar.rat";
            },
            defeatDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopCellar.firstDefeatRat")) return "shopCellar.firstDefeatRat";
                return "shopCellar.defeatRat";
            },
            level: 1,
            hp: 15,
            maxHp: 15,
            attack: 2,
            magicAttack: 2,
            defense: 10,
            magicDefense: 10,
            gold: 5
        }
    ]
};


const $3818cd2544b0f4c9$export$99afa4260497c8be = [
    {
        name: "shopCellarEntrance",
        width: 7,
        height: 7,
        pathImage: "cobblestone",
        wallImage: "stoneBrick",
        combatKey: "shopCellar",
        combat: {
            ...(0, $b7a927103247c962$export$79f4124ce8bee305)
        },
        walls: [
            "top"
        ],
        tiles: [
            {
                type: "entrance",
                x: 3,
                y: 0,
                tileImage: "cellarDoor",
                location: "elarianShop",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 3,
                y: 6,
                tileImage: "door",
                location: "shopCellarBossRoom",
                tileBackground: "wall",
                outputDirection: "down"
            },
            {
                type: "object",
                x: 0,
                y: 5,
                tileImage: "chest",
                dialogueFunction: ()=>"shopCellar.treasure1",
                displayFunction: ()=>"Open the chest",
                noMovement: true
            },
            {
                type: "object",
                x: 6,
                y: 5,
                tileImage: "chest",
                dialogueFunction: ()=>"shopCellar.treasure2",
                displayFunction: ()=>"Open the chest",
                noMovement: true
            }
        ]
    },
    {
        name: "shopCellarBossRoom",
        width: 5,
        height: 7,
        pathImage: "cobblestone",
        wallImage: "stoneBrick",
        combatKey: "shopCellar",
        combat: {
            ...(0, $b7a927103247c962$export$79f4124ce8bee305)
        },
        walls: [
            "top",
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "door",
                location: "shopCellarEntrance",
                tileBackground: "wall",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 2,
                y: 6,
                tileImage: "door",
                location: "shopCellarWineRoom",
                tileBackground: "wall",
                outputDirection: "down"
            }
        ]
    },
    {
        name: "shopCellarWineRoom",
        width: 3,
        height: 4,
        pathImage: "cobblestone",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 1,
                y: 0,
                tileImage: "door",
                location: "shopCellarBossRoom",
                tileBackground: "wall",
                outputDirection: "up"
            },
            {
                type: "object",
                x: 1,
                y: 2,
                tileImage: "chest",
                dialogueFunction: ()=>"shopCellar.wine",
                displayFunction: ()=>"Take the wine",
                noMovement: true
            }
        ]
    }
];



const $2ac8cee356f0b1a5$export$4f83c5df3c20ecda = [
    ...(0, $3818cd2544b0f4c9$export$99afa4260497c8be),
    {
        name: "elarianGates",
        width: 5,
        height: 6,
        pathImage: "grass",
        wallImage: "stoneBrick",
        walls: [
            "top"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 5,
                tileImage: "castleGate",
                tileBackground: "wall",
                location: "elarian",
                outputDirection: "down"
            }
        ]
    },
    {
        name: "elarian",
        width: 9,
        height: 9,
        pathImage: "grass",
        wallImage: "stoneBrick",
        walls: [
            "top",
            "left",
            "right",
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 4,
                y: 0,
                tileImage: "castleGate",
                tileBackground: "wall",
                location: "elarianGates",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 2,
                y: 2,
                tileImage: "shop",
                location: "elarianShop",
                outputDirection: "down"
            },
            {
                type: "entrance",
                x: 6,
                y: 2,
                tileImage: "tower",
                location: "elarianTower",
                outputDirection: "down"
            },
            {
                type: "entrance",
                x: 2,
                y: 6,
                tileImage: "cathedral",
                outputDirection: "down",
                location: "elarianCathedral"
            },
            {
                type: "entrance",
                x: 6,
                y: 6,
                tileImage: "castle",
                outputDirection: "down",
                location: "elarianCastle"
            },
            {
                type: "entrance",
                x: 4,
                y: 8,
                tileImage: "castleGate",
                tileBackground: "wall",
                outputDirection: "down",
                location: "elarianCourtyard"
            }
        ]
    },
    {
        name: "elarianShop",
        width: 5,
        height: 6,
        pathImage: "woodFloor",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "door",
                tileBackground: "wall",
                location: "elarian",
                outputDirection: "up"
            },
            {
                type: "object",
                x: 0,
                y: 3,
                tileImage: "counter",
                "z-index": 3
            },
            {
                type: "entrance",
                x: 4,
                y: 5,
                tileImage: "cellarDoor",
                location: "shopCellarEntrance",
                locked: true,
                lockedDialogue: "elarianShop.lockedCellar",
                outputDirection: "down"
            }
        ]
    },
    {
        name: "elarianTower",
        width: 5,
        height: 6,
        pathImage: "woodFloor",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "door",
                tileBackground: "wall",
                location: "elarian",
                outputDirection: "up"
            },
            {
                type: "object",
                x: 2,
                y: 3,
                tileImage: "cauldron",
                "z-index": 3
            },
            {
                type: "object",
                x: 0,
                y: 5,
                tileImage: "bookshelf",
                noMovement: true
            },
            {
                type: "object",
                x: 1,
                y: 5,
                tileImage: "bookshelf",
                noMovement: true
            },
            {
                type: "object",
                x: 2,
                y: 5,
                tileImage: "bookshelf",
                noMovement: true
            },
            {
                type: "object",
                x: 3,
                y: 5,
                tileImage: "bookshelf",
                noMovement: true
            },
            {
                type: "object",
                x: 4,
                y: 5,
                tileImage: "bookshelf",
                noMovement: true
            }
        ]
    },
    {
        name: "elarianCathedral",
        width: 5,
        height: 6,
        pathImage: "woodFloor",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "door",
                tileBackground: "wall",
                location: "elarian",
                outputDirection: "up"
            },
            {
                type: "object",
                x: 0,
                y: 5,
                tileImage: "stainedGlass1",
                tileBackground: "wall",
                noMovement: true
            },
            {
                type: "object",
                x: 1,
                y: 5,
                tileImage: "stainedGlass2",
                tileBackground: "wall",
                noMovement: true
            },
            {
                type: "object",
                x: 2,
                y: 5,
                tileImage: "altar",
                noMovement: true
            },
            {
                type: "object",
                x: 3,
                y: 5,
                tileImage: "stainedGlass3",
                tileBackground: "wall",
                noMovement: true
            },
            {
                type: "object",
                x: 4,
                y: 5,
                tileImage: "stainedGlass4",
                tileBackground: "wall",
                noMovement: true
            }
        ]
    },
    {
        name: "elarianCastle",
        width: 5,
        height: 6,
        pathImage: "woodFloor",
        wallImage: "stoneBrick",
        walls: [
            "bottom",
            "top"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "door",
                tileBackground: "wall",
                location: "elarian",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 2,
                y: 5,
                tileImage: "castleGate",
                tileBackground: "wall",
                outputDirection: "down",
                location: "elarianThroneRoom"
            }
        ]
    },
    {
        name: "elarianThroneRoom",
        width: 5,
        height: 6,
        pathImage: "woodFloor",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "wall",
                x: 0,
                y: 0
            },
            {
                type: "wall",
                x: 1,
                y: 0
            },
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "castleGate",
                tileBackground: "wall",
                location: "elarianCastle",
                outputDirection: "up"
            },
            {
                type: "wall",
                x: 3,
                y: 0
            },
            {
                type: "wall",
                x: 4,
                y: 0
            },
            {
                type: "object",
                x: 2,
                y: 4,
                tileImage: "throne"
            }
        ]
    },
    {
        name: "elarianCourtyard",
        width: 7,
        height: 7,
        pathImage: "grass",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "object",
                x: 0,
                y: 6,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 1,
                y: 6,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 2,
                y: 6,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 4,
                y: 6,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 5,
                y: 6,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 6,
                y: 6,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "entrance",
                x: 3,
                y: 0,
                tileImage: "castleGate",
                tileBackground: "wall",
                location: "elarian",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 3,
                y: 6,
                locked: true,
                lockedDialogue: "courtyardGuard.lockedForest",
                location: "goblinForestBottom2",
                outputDirection: "down"
            },
            {
                type: "object",
                x: 3,
                y: 3,
                tileImage: "dragonStatue",
                noMovement: true,
                displayFunction: ()=>{
                    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("elarianCourtyard.investigateDragonStatue")) return "Investigate the dragon statue";
                    else return "Put your sword in the slit";
                },
                dialogueFunction: ()=>{
                    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("elarianCourtyard.investigateDragonStatue")) return "elarianCourtyard.investigateDragonStatue";
                    return "elarianCourtyard.statueActions";
                }
            }
        ]
    }
];



const $b52aa9bfd699abd3$export$3ba2bda326b3d98 = {
    combatKey: "goblinForest",
    encounterRate: "low",
    enemies: [
        {
            name: "goblet",
            tileImage: "goblet",
            encounterDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinForest.firstGoblet")) return "goblinForest.firstGoblet";
                return "goblinForest.goblet";
            },
            defeatDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinForest.firstDefeatGoblet")) return "goblinForest.firstDefeatGoblet";
                return "goblinForest.defeatGoblet";
            },
            level: 3,
            hp: 20,
            maxHp: 20,
            attack: 15,
            magicAttack: 15,
            defense: 15,
            magicDefense: 25,
            gold: 10
        },
        {
            name: "goblin",
            tileImage: "goblin",
            encounterDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinForest.firstGoblin")) return "goblinForest.firstGoblin";
                return "goblinForest.goblin";
            },
            defeatDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinForest.firstDefeatGoblin")) return "goblinForest.firstDefeatGoblin";
                return "goblinForest.defeatGoblin";
            },
            level: 5,
            hp: 30,
            maxHp: 30,
            attack: 25,
            magicAttack: 25,
            defense: 15,
            magicDefense: 15,
            gold: 20
        },
        {
            name: "ogre",
            tileImage: "ogre",
            encounterDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinForest.firstOgre")) return "goblinForest.firstOgre";
                return "goblinForest.ogre";
            },
            defeatDialogueFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinForest.firstDefeatOgre")) return "goblinForest.firstDefeatOgre";
                return "goblinForest.defeatOgre";
            },
            level: 10,
            hp: 50,
            maxHp: 50,
            attack: 35,
            magicAttack: 35,
            defense: 45,
            magicDefense: 25,
            gold: 30
        }
    ]
};


// Goblin Forest Layout
//                     T2 (to Mirewood Courtyard)
//                     T1
// (Goblin Camp) L2 L1 C  R1 R2 (Chests)
//                     B1
//                     B2 (to Elarian Courtyard)
const $5216997f1c89315d$export$26362de1d76de1f2 = [
    {
        name: "goblinForestRight2",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 0,
                y: 3,
                location: "goblinForestRight1",
                outputDirection: "right"
            },
            {
                type: "object",
                x: 7,
                y: 2,
                tileImage: "chest",
                dialogueFunction: ()=>"goblinForest.treasureRight1",
                displayFunction: ()=>"Open the chest",
                noMovement: true
            },
            {
                type: "object",
                x: 7,
                y: 5,
                tileImage: "chest",
                dialogueFunction: ()=>"goblinForest.treasureRight2",
                displayFunction: ()=>"Open the chest",
                noMovement: true
            }
        ]
    },
    {
        name: "goblinForestRight1",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 8,
                y: 3,
                location: "goblinForestRight2",
                outputDirection: "left"
            },
            {
                type: "entrance",
                x: 0,
                y: 3,
                location: "goblinForestCenter",
                outputDirection: "right"
            }
        ]
    },
    {
        name: "goblinForestCenter",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 8,
                y: 3,
                location: "goblinForestRight1",
                outputDirection: "left"
            },
            {
                type: "entrance",
                x: 4,
                y: 0,
                location: "goblinForestBottom1",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 4,
                y: 6,
                location: "goblinForestTop1",
                outputDirection: "down"
            },
            {
                type: "entrance",
                x: 0,
                y: 3,
                location: "goblinForestLeft1",
                outputDirection: "right"
            }
        ]
    },
    {
        name: "goblinForestBottom1",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 4,
                y: 6,
                location: "goblinForestCenter",
                outputDirection: "down"
            },
            {
                type: "entrance",
                x: 4,
                y: 0,
                location: "goblinForestBottom2",
                outputDirection: "up"
            }
        ]
    },
    {
        name: "goblinForestTop1",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 4,
                y: 0,
                location: "goblinForestCenter",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 4,
                y: 6,
                location: "goblinForestTop2",
                outputDirection: "down"
            }
        ]
    },
    {
        name: "goblinForestLeft1",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 8,
                y: 3,
                location: "goblinForestCenter",
                outputDirection: "left"
            },
            {
                type: "entrance",
                x: 0,
                y: 3,
                location: "goblinForestLeft2",
                outputDirection: "right"
            }
        ]
    },
    {
        name: "goblinForestBottom2",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 4,
                y: 6,
                location: "goblinForestBottom1",
                outputDirection: "down"
            },
            {
                type: "entrance",
                x: 4,
                y: 0,
                location: "elarianCourtyard",
                outputDirection: "up"
            }
        ]
    },
    {
        name: "goblinForestTop2",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 4,
                y: 0,
                location: "goblinForestTop1",
                outputDirection: "up"
            },
            {
                type: "entrance",
                x: 4,
                y: 6,
                location: "mirewoodCourtyard",
                outputDirection: "down"
            }
        ]
    },
    {
        name: "goblinForestLeft2",
        width: 9,
        height: 7,
        pathImage: "forestGrass",
        wallObject: {
            type: "object",
            tileImage: "tree",
            noMovement: true
        },
        walls: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        combat: {
            ...(0, $b52aa9bfd699abd3$export$3ba2bda326b3d98)
        },
        tiles: [
            {
                type: "entrance",
                x: 8,
                y: 3,
                location: "goblinForestLeft1",
                outputDirection: "left"
            },
            {
                type: "entrance",
                x: 4,
                y: 5,
                location: "goblinCamp",
                outputDirection: "down",
                tileImage: "goblinCamp"
            }
        ]
    },
    {
        name: "goblinCamp",
        width: 5,
        height: 6,
        pathImage: "forestGrass",
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                location: "goblinForestLeft2",
                outputDirection: "up"
            }
        ]
    }
];



const $9777b809b07ee19a$export$ca97b1f169fe524a = [
    {
        name: "mirewoodCourtyard",
        width: 7,
        height: 7,
        pathImage: "swampFloor",
        tiles: [
            {
                type: "object",
                x: 0,
                y: 0,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 1,
                y: 0,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 2,
                y: 0,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 4,
                y: 0,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 5,
                y: 0,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "object",
                x: 6,
                y: 0,
                tileImage: "tree",
                noMovement: true
            },
            {
                type: "entrance",
                x: 3,
                y: 0,
                location: "goblinForestTop2",
                outputDirection: "up"
            },
            {
                type: "object",
                x: 3,
                y: 3,
                tileImage: "basiliskStatue",
                noMovement: true,
                displayFunction: ()=>{
                    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("mirewoodCourtyard.investigateBasiliskStatue")) return "Investigate the basilisk statue";
                    else return "Put your sword in the slit";
                },
                dialogueFunction: ()=>{
                    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("mirewoodCourtyard.investigateBasiliskStatue")) return "mirewoodCourtyard.investigateBasiliskStatue";
                    return "mirewoodCourtyard.statueActions";
                }
            },
            {
                type: "entrance",
                x: 3,
                y: 6,
                location: "mirewood",
                outputDirection: "down"
            }
        ]
    },
    {
        name: "mirewood",
        width: 9,
        height: 9,
        pathImage: "swampFloor",
        tiles: [
            {
                type: "entrance",
                x: 4,
                y: 0,
                location: "mirewoodCourtyard",
                outputDirection: "up"
            },
            // { type: 'entrance', x: 6, y: 6, tileImage: 'mirewoodTavern', location: 'mirewoodTavern', outputDirection: 'down' },
            // { type: 'entrance', x: 2, y: 6, tileImage: 'mirewoodHouse', outputDirection: 'down', location: 'mirewoodHouse' },
            {
                type: "entrance",
                x: 4,
                y: 4,
                tileImage: "witchHut",
                outputDirection: "down",
                location: "witchHut"
            },
            {
                type: "object",
                x: 4,
                y: 3,
                tileImage: "giantTree"
            }
        ]
    },
    {
        name: "witchHut",
        width: 5,
        height: 6,
        pathImage: "woodFloor",
        wallImage: "stoneBrick",
        walls: [
            "bottom"
        ],
        tiles: [
            {
                type: "entrance",
                x: 2,
                y: 0,
                tileImage: "door",
                tileBackground: "wall",
                location: "mirewood",
                outputDirection: "up"
            },
            {
                type: "object",
                x: 2,
                y: 3,
                tileImage: "cauldron",
                "z-index": 3
            },
            {
                type: "object",
                x: 0,
                y: 5,
                tileImage: "bookshelf",
                noMovement: true
            }
        ]
    }
];






const $e8cb25eed9e12d69$var$dialogues = {
    fatherMichael: {
        talk: {
            textFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("fatherMichael.talk")) return `"Welcome to the Elarian cathedral. I am Father Michael. How can I help you?"`;
                else return `"Is there anything I can help you with?"`;
            },
            options: [
                {
                    requires: {
                        not: "fatherMichael.talk.about"
                    },
                    display: "Ask about Michael",
                    text: `"What do you do here, Father?"`,
                    next: "fatherMichael.talk.about"
                },
                {
                    requires: {
                        not: "fatherMichael.talk.aboutCathedral"
                    },
                    display: "Ask about the cathedral",
                    text: `"Can you tell me more about the cathedral?"`,
                    next: "fatherMichael.talk.aboutCathedral"
                },
                {
                    // If you already talked to Cedric about seeing the king, this option will not show.
                    requires: {
                        and: [
                            {
                                not: "shopkeeperCedric.talk.seeTheKing"
                            },
                            {
                                not: "fatherMichael.talk.seeTheKing"
                            }
                        ]
                    },
                    display: "Ask about speaking with the king",
                    text: `"Do you know how I could speak with the king?"`,
                    next: "fatherMichael.talk.seeTheKing"
                },
                {
                    display: "Ask for a prayer",
                    text: `"Can you say a prayer for me?"`,
                    next: "fatherMichael.talk.prayer"
                },
                {
                    display: "Nevermind",
                    function: ()=>{
                        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
                    }
                }
            ],
            about: {
                text: `"I am the head of the Elarian church and I am responsible for the spiritual well-being of the people."`
            },
            aboutCathedral: {
                text: `"The cathedral was built hundreds of years ago. It is one of the oldest buildings in the city. The cathedral is a place of worship and a place of refuge for those in need."`
            },
            seeTheKing: {
                text: `"If you wish to speak with the king, you should talk to Cedric, the shopkeeper. Cedric knows the king well and might be able to help."`
            },
            prayer: {
                text: `"Of course. Which prayer would you like me to say for you?"`,
                options: [
                    {
                        display: "Ask for a Hail Mary",
                        text: `"A Hail Mary."`,
                        next: "fatherMichael.talk.prayer.hailMary"
                    },
                    {
                        display: "Ask for an Our Father",
                        text: `"An Our Father."`,
                        next: "fatherMichael.talk.prayer.ourFather"
                    },
                    {
                        display: "Ask for a Glory Be",
                        text: `"A Glory Be."`,
                        next: "fatherMichael.talk.prayer.gloryBe"
                    },
                    {
                        display: "Ask for a blessing",
                        text: `"Can you give me a blessing, Father?"`,
                        next: "fatherMichael.talk.prayer.blessing"
                    }
                ],
                hailMary: {
                    text: `"Hail Mary, full of grace, the Lord is with thee; blessed art thou among women, and blessed is the fruit of thy womb, Jesus. Holy Mary, Mother of God, pray for us sinners, now and at the hour of our death. Amen."`
                },
                ourFather: {
                    text: `"Our Father who art in heaven, hallowed be thy name. Thy kingdom come. Thy will be done on earth as it is in heaven. Give us this day our daily bread. And forgive us our trespasses, as we forgive those who trespass against us. And lead us not into temptation, but deliver us from evil. Amen."`
                },
                gloryBe: {
                    text: `"Glory be to the Father, and to the Son, and to the Holy Spirit. As it was in the beginning, is now, and ever shall be, world without end. Amen."`
                },
                blessing: {
                    text: `"May the Lord bless you and keep you. May the Lord make his face to shine upon you, and be gracious to you. May the Lord lift up his countenance upon you, and give you peace."`
                }
            }
        }
    }
};
const $e8cb25eed9e12d69$var$npc = {
    type: "npc",
    location: "elarianCathedral",
    x: 2,
    y: 4,
    name: "Father Michael",
    tileImage: "fatherMichael",
    dialogueKey: "fatherMichael",
    dialogueFunction: ()=>"fatherMichael.talk"
};
const $e8cb25eed9e12d69$export$2896fb787da8416d = {
    npc: $e8cb25eed9e12d69$var$npc,
    dialogues: $e8cb25eed9e12d69$var$dialogues
};









const $99a1b7580a9713be$export$7408eeab301af673 = (shopItems, shopkeeperName)=>{
    const buyOptions = [
        ...shopItems.map((item)=>({
                ...item.oneTime ? {
                    requires: {
                        not: `${shopkeeperName}.talk.buy.buy${item.name}`
                    }
                } : {},
                display: `Ask about the ${item.displayName} (${item.price} gold)`,
                //text: `"Tell me about the ${item.displayName}."`,
                next: `${shopkeeperName}.talk.buy.${item.name}`
            })),
        {
            display: "Nevermind",
            function: ()=>{
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
            }
        }
    ];
    return {
        buy: {
            text: `"Here, take a look! Is there anything you are interested in?"`,
            options: buyOptions,
            ...shopItems.reduce((acc, item)=>{
                acc[item.name] = {
                    text: item.text,
                    options: [
                        {
                            display: `Buy the ${item.displayName} (${item.price} gold)`,
                            nextFunction: ()=>{
                                if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).gold < item.price) return `${shopkeeperName}.talk.buy.cantBuy${item.name}`;
                                else return `${shopkeeperName}.talk.buy.buy${item.name}`;
                            }
                        },
                        {
                            display: "Back",
                            next: `${shopkeeperName}.talk.buyQuestionOnly`
                        }
                    ]
                };
                acc[`cantBuy${item.name}`] = {
                    text: `"You don't have enough gold for that."`,
                    next: `${shopkeeperName}.talk.buyQuestionOnly`
                };
                acc[`buy${item.name}`] = {
                    text: `"Thank you for your purchase!"`,
                    function: ()=>{
                        (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateGold(-item.price);
                        item.buyFunction();
                    },
                    next: `${shopkeeperName}.talk.buyQuestionOnly`
                };
                return acc;
            }, {})
        },
        buyQuestionOnly: {
            text: `"Is there anything you are interested in?"`,
            options: buyOptions
        }
    };
};


const $6d8b15a0bbbd9e23$var$shopItems = [
    {
        name: "bladeSharpener",
        displayName: "blade sharpener",
        price: 100,
        text: `"The blade sharpener is a must-have for any adventurer. It will make your sword sharper and more effective in battle." (Attack +10)`,
        oneTime: true,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).attack += 10;
        }
    },
    {
        name: "magicGloves",
        displayName: "magic gloves",
        price: 100,
        text: `"The magic gloves will increase your magic power and make your spells more effective." (Magic Attack +10)`,
        oneTime: true,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).magicAttack += 10;
        }
    },
    {
        name: "armorPolish",
        displayName: "armor polish",
        price: 150,
        text: `"The armor polish will make your armor more durable and resistant to enemy attacks." (Defense +10)`,
        oneTime: true,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).defense += 10;
        }
    },
    {
        name: "healthElixir",
        displayName: "health elixir",
        price: 200,
        text: `"The health elixir will increase your maximum health." (Max HP +10)`,
        oneTime: true,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp += 10;
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp += 10;
            (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateHealthBar();
        }
    },
    {
        name: "ogreSpray",
        displayName: "ogre spray",
        price: 25,
        text: `"The ogre spray can be used to cause an ogre to flee from battle. It is a necessity if you plan on traveling through the forest. You can use it up to three times."`,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.push({
                name: "Ogre Spray",
                type: "combatItem",
                uses: 3,
                useDialogue: "goblinForest.ogreSpray"
            });
        }
    }
];
const $6d8b15a0bbbd9e23$var$dialogues = {
    shopkeeperCedric: {
        talk: {
            textFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopkeeperCedric.talk")) return `"Welcome! Cedric at your service, shopkeeper extraordinaire. What can I do for you today?"`;
                return `"Is there anything I can help you with?"`;
            },
            options: [
                {
                    // Only show this option if directed here from the guards or the priest.
                    requires: {
                        and: [
                            {
                                not: "shopkeeperCedric.talk.seeTheKing"
                            },
                            {
                                or: [
                                    {
                                        check: "elarianGuard.talk.seeTheKing"
                                    },
                                    {
                                        check: "fatherMichael.talk.seeTheKing"
                                    }
                                ]
                            }
                        ]
                    },
                    display: "Ask about speaking with the king",
                    text: `"Do you know how I could speak with the king?"`,
                    next: "shopkeeperCedric.talk.seeTheKing"
                },
                {
                    // You need to retrieve the wine from the cellar before this option will show.
                    requires: {
                        and: [
                            {
                                check: "shopCellar.wine"
                            },
                            {
                                not: "shopkeeperCedric.talk.cedricWine"
                            }
                        ]
                    },
                    display: "Tell him that you have retrieved the wine",
                    text: `"You didn't tell me about the rat boss in your cellar. I took care of him and retrieved the wine."`,
                    next: "shopkeeperCedric.talk.cedricWine"
                },
                {
                    requires: {
                        and: [
                            {
                                inventory: "King's Crown"
                            },
                            {
                                not: "shopkeeperCedric.talk.gotCrown"
                            }
                        ]
                    },
                    display: "Tell him that you have retrieved the crown",
                    text: `"I've retrieved the king's crown from the Goblin King."`,
                    next: "shopkeeperCedric.talk.gotCrown"
                },
                {
                    display: "Ask what he has for sale",
                    text: `"What do you have for sale?"`,
                    nextFunction: ()=>{
                        if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopkeeperCedric.talk.cedricWine")) return "shopkeeperCedric.talk.buy";
                        else return "shopkeeperCedric.talk.cantBuy";
                    }
                },
                {
                    display: "Nevermind",
                    function: ()=>{
                        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
                    }
                }
            ],
            seeTheKing: {
                text: `"I wish I could help you, but I don't know how to speak with the king. I'm just a humble shopkeeper."`,
                options: [
                    {
                        display: "Ask why you were told he would be able to help",
                        text: `"I was told specifically to speak with you about seeing the king."`,
                        next: "shopkeeperCedric.talk.seeTheKing.askWhy"
                    }
                ],
                askWhy: {
                    text: `"I'm not sure why you were told that. I'm just a humble shopkeeper."`,
                    options: [
                        {
                            display: "Insist that he must know something",
                            text: `"They wouldn't have sent me to you for no reason. Please, tell me how I can see the king."`,
                            next: "shopkeeperCedric.talk.seeTheKing.askWhy.insist"
                        },
                        {
                            display: "Answer sarcastically",
                            text: `"I get it. You're just a humble shopkeeper. But seriously, how can I see the king?"`,
                            next: "shopkeeperCedric.talk.seeTheKing.askWhy.insist"
                        }
                    ],
                    insist: {
                        text: `"Alright, fine. I used to be on good terms with the king, but that was back when I supplied his wine. Ever since the rats infested my cellar, I haven't been able to reach my vintage wine supply. If I had the wine, I could probably get you an audience with the king."`,
                        options: [
                            {
                                display: "Offer to retrieve the wine from the cellar",
                                text: `"I have dealt with rats before. I can retrieve the wine for you."`,
                                next: "shopkeeperCedric.talk.seeTheKing.askWhy.insist.retrieveWine"
                            },
                            {
                                display: "Ask if there is another way to get wine",
                                text: `"Your cellar can't be the only place to get wine. Is there another option?"`,
                                next: "shopkeeperCedric.talk.seeTheKing.askWhy.insist.anotherWay"
                            }
                        ],
                        anotherWay: {
                            text: `"My wine is the best in the city. The king won't accept anything less. If you can't get the wine from my cellar, you might as well give up on seeing the king."`,
                            options: [
                                {
                                    display: "Offer to retrieve the wine from the cellar",
                                    text: `"Alright, I'll get the wine from your cellar."`,
                                    next: "shopkeeperCedric.talk.seeTheKing.askWhy.insist.retrieveWine"
                                },
                                {
                                    display: "Offer to retrieve the wine from the cellar (sarcastic)",
                                    text: `"I didn't realize a humble shopkeeper such as yourself had the best wine in the city. I'll get it for you."`,
                                    next: "shopkeeperCedric.talk.seeTheKing.askWhy.insist.retrieveWine"
                                }
                            ]
                        },
                        retrieveWine: {
                            text: `"You would do that? Oh, thank you! The cellar is just down the stairs. Be careful, though... The rats are vicious."`,
                            function: ()=>{
                                (0, $846df9480552348c$export$17b07c660794dc13).unlockEntrance("elarianShop", "shopCellarEntrance");
                            }
                        }
                    }
                }
            },
            cantBuy: {
                text: `"Sorry, we are out of stock right now. The rats have eaten everything. We should be getting a fresh shipment soon."`
            },
            ...(0, $99a1b7580a9713be$export$7408eeab301af673)($6d8b15a0bbbd9e23$var$shopItems, "shopkeeperCedric"),
            cedricWine: {
                text: `"Oh, did I forget to mention that? I thought I said something about that vicious rat.
          Anyways... let's go deliver this to the king together! I will meet you at the castle."`,
                function: async ()=>{
                    // Move Cedric over two, then down three tiles, with a short delay between each move. Then move Cedric to the castle.
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "right");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "right");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Cedric", "elarianShop", "elarianCastle", 1, 3);
                }
            },
            gotCrown: {
                text: `"You've retrieved the crown? That's fantastic! We should head to the castle right away to deliver it to the king."`,
                function: async ()=>{
                    // Move Cedric to the castle, similar to the wine delivery scene
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "right");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "right");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianShop", "Cedric", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Cedric", "elarianShop", "elarianCastle", 1, 3);
                }
            }
        },
        preWineDelivery: {
            text: `"We should talk to the guards so they can let us in."`
        },
        wineDelivery: {
            text: `"I'm great! I finally got my hands on some more of the king's favorite wine. 
        My friend here took care of the rat boss that was in my cellar and retrieved it for me."`,
            next: "castleGuard.wineDelivery2"
        },
        wineDelivery2: {
            text: `"Well, I was actually hoping to deliver it in person. I haven't seen the king in a while and my friend here would like to meet him."`,
            next: "castleGuard.wineDelivery3"
        },
        wineDelivery3: {
            text: `"Is there any way you could make an exception? I'm sure the king would be happy to see me."`,
            next: "castleGuard.wineDelivery4"
        },
        wineDelivery4: {
            text: `"Yes, he did! What do you need help with?"`,
            next: "castleGuard.askForCrown"
        },
        wineDelivery5: {
            text: `"Good luck, Thaddeus! I will head back to my shop. You might need to buy some items from me before you head out."`,
            function: async ()=>{
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCastle", "Cedric", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCastle", "Cedric", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCastle", "Cedric", "right");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Cedric", "elarianCastle", "elarianShop", 0, 4);
            }
        },
        preCrownDelivery: {
            text: `"We should talk to the guards so they can let us in."`
        },
        throneRoomWineDelivery: {
            text: `"Your Majesty, it brings me great joy to present you with your favorite vintage. I hope it meets your expectations as always."`,
            next: "kingRehoboam.wineResponse"
        },
        throneRoomDeparture: {
            text: `"Thank you, Your Majesty. Thaddeus, I'll be heading back to my shop now. Feel free to visit if you need any supplies for your quest."`,
            function: async ()=>{
                // Move Cedric out of the throne room
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianThroneRoom", "Cedric", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianThroneRoom", "Cedric", "left");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Cedric", "elarianThroneRoom", "elarianShop", 0, 4);
            }
        }
    }
};
const $6d8b15a0bbbd9e23$var$npc = {
    type: "npc",
    location: "elarianShop",
    x: 0,
    y: 4,
    name: "Cedric",
    tileImage: "shopkeeperCedric",
    dialogueKey: "shopkeeperCedric",
    dialogueFunction: ()=>{
        if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopkeeperCedric.talk.cedricWine") && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.wineDelivery")) return "shopkeeperCedric.preWineDelivery";
        else if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopkeeperCedric.talk.gotCrown") && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.crownDeliveryWithCedric")) return "shopkeeperCedric.preCrownDelivery";
        else return "shopkeeperCedric.talk";
    }
};
const $6d8b15a0bbbd9e23$export$aad27058eca608a = {
    npc: $6d8b15a0bbbd9e23$var$npc,
    dialogues: $6d8b15a0bbbd9e23$var$dialogues
};






const $9b12285638816587$var$restoreHealth = ()=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp;
    (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateHealthBar();
    (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateMagicBar();
};
const $9b12285638816587$var$faint = async ()=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x = 3;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y = 4;
    delete (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy;
    (0, $846df9480552348c$export$17b07c660794dc13).showDisplay();
    await (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("elarianTower");
    $9b12285638816587$var$restoreHealth();
};
const $9b12285638816587$var$dialogues = {
    wizardEldwin: {
        talk: {
            textFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("wizardEldwin.talk")) return `"Ah, a visitor! Welcome to my humble tower! I am Eldwin. What can I do for you?"`;
                return `"Is there anything I can help you with?"`;
            },
            options: [
                {
                    requires: {
                        not: "wizardEldwin.talk.about"
                    },
                    display: "Ask about Eldwin",
                    text: `"Could you tell me more about yourself, Eldwin?"`,
                    next: "wizardEldwin.talk.about"
                },
                {
                    requires: {
                        not: "wizardEldwin.talk.learnMagic"
                    },
                    display: "Ask if he can teach you magic",
                    text: `"Would you be willing to teach me some magic?"`,
                    nextFunction: ()=>{
                        if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("wizardEldwin.firstFaint")) return "wizardEldwin.talk.cantLearnMagic";
                        else return "wizardEldwin.talk.learnMagic";
                    }
                },
                {
                    requires: {
                        and: [
                            {
                                check: "kingRehoboam.audienceConclusion"
                            },
                            {
                                not: "wizardEldwin.talk.explainPlan"
                            }
                        ]
                    },
                    display: "Ask about the plan",
                    text: `"The king mentioned a plan to defeat the Dark One. Can you tell me more about it?"`,
                    next: "wizardEldwin.talk.explainPlan"
                },
                {
                    display: `Ask to restore your health`,
                    text: `"Can you restore my health?"`,
                    nextFunction: ()=>{
                        if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp && (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp) return "wizardEldwin.talk.fullHealth";
                        else return "wizardEldwin.talk.restoreHealth";
                    }
                },
                {
                    display: "Nevermind",
                    function: ()=>{
                        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
                    }
                }
            ],
            about: {
                text: `"I have been studying magic in my tower for decades. I have mastered the art of casting spells and have just started to experiment with potions."`
            },
            cantLearnMagic: {
                text: `"I could teach you some basic spells, but first you will need combat experience. Come back when you have fought in a few battles."`
            },
            learnMagic: {
                text: `"Let me walk you through how to use magic. You only have a limited amount of magic that you can use before you need to recover. You can only recover magic when you use a physical attack. By using magic attacks, you should have the strength you need to defeat the rat boss. Good luck!"`,
                prefunction: ()=>{
                    (0, $504c2f61098a857b$export$7debb50ef11d5e0b).revealMagic();
                    (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateMagicBar();
                }
            },
            fullHealth: {
                text: `"You are already at full health, my friend."`
            },
            restoreHealth: {
                text: `"There you go! You are now at full health."`,
                prefunction: $9b12285638816587$var$restoreHealth
            },
            explainPlan: {
                text: `"Ah, yes, of course. The Dark One's power comes from an ancient artifact known as the Shadowstone. If we can destroy it, we can defeat the Dark One. However, the Shadowstone is protected by his minions, deep within his fortress."`,
                next: "wizardEldwin.talk.continueExplanation"
            },
            continueExplanation: {
                text: `"I am working on a potion that will make you look like one of the Dark One's minions. If you can infiltrate his fortress and get close enough to the Shadowstone, you can destroy it from the inside."`,
                next: "wizardEldwin.talk.finalExplanation"
            },
            finalExplanation: {
                text: `"But, there's a catch. I still need three more ingredients to finish the potion and I will need your help to retrieve them."`,
                options: [
                    {
                        display: "Offer to help Eldwin",
                        text: `"I will help you gather the ingredients. What exactly do you need?"`,
                        next: "wizardEldwin.talk.finalExplanation.offerHelp"
                    }
                ],
                offerHelp: {
                    text: `"The developer of this game, Phoenix Flame, has not yet told me what the ingredients are. But, I am sure they will be interesting to find. Thank you for playing beta version 0.3 of Glenfall!"`
                }
            }
        },
        firstFaint: {
            text: `"You passed out in the cellar and I brought you here to recover. You are now at full health, my friend. Learning some magic could help you defeat the rat boss. I can teach you some basic spells if you are interested."`,
            prefunction: async ()=>{
                await $9b12285638816587$var$faint();
                // Set the talk dialogue to seen so that Eldwin doesn't call you a visitor.
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).setDialogueSeen("wizardEldwin.talk");
            }
        },
        faint: {
            text: `"I have restored you to full health. You should be more careful out there, my friend."`,
            prefunction: $9b12285638816587$var$faint
        }
    }
};
const $9b12285638816587$var$npc = {
    type: "npc",
    location: "elarianTower",
    x: 2,
    y: 4,
    name: "Eldwin",
    tileImage: "wizardEldwin",
    dialogueKey: "wizardEldwin",
    dialogueFunction: ()=>"wizardEldwin.talk"
};
const $9b12285638816587$export$95524992ae3478c8 = {
    npc: $9b12285638816587$var$npc,
    dialogues: $9b12285638816587$var$dialogues
};



const $efd6490a4c2330eb$var$dialogues = {
    jesterJeffrey: {
        talk: {
            textFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("jesterJeffrey.talk")) return `"I'm Jester Jeffrey. Do you want to hear a joke?"`;
                return `"Do you want to hear a joke?"`;
            },
            options: [
                {
                    display: "Yes",
                    text: `"Sure, why not?"`,
                    next: "jesterJeffrey.talk.joke"
                },
                {
                    display: "No",
                    text: `"Not really in the mood for jokes right now."`,
                    next: "jesterJeffrey.talk.noJoke"
                }
            ],
            joke: {
                textFunction: ()=>{
                    const jokes = [
                        `"What's a monarch's favorite type of precipitation? Reign!"`,
                        `"Why did the peasant bring a ladder to the tavern? He heard the drinks were on the house!"`,
                        `"What do you call a knight who's afraid to fight? Sir Render!"`,
                        `"Why did the king go to the dentist? To get his teeth crowned!"`,
                        `"What's a wizard's favorite subject in school? Spelling!"`,
                        `"Three dragons walk into a tavern... There were no survivors."`,
                        `"Why are knights always so tired? Because they work the knight shift!"`,
                        `"What do you call a horse that lives next door? A neigh-bor!"`,
                        `"Why did the castle break up with the drawbridge? It couldn't handle the ups and downs of the relationship!"`,
                        `"Why were the early days of the kingdom called the Dark Ages? Because there were so many knights!"`
                    ];
                    return jokes[Math.floor(Math.random() * jokes.length)];
                }
            },
            noJoke: {
                text: `"That's a shame. I have some good ones."`
            }
        }
    }
};
const $efd6490a4c2330eb$var$npc = {
    type: "npc",
    location: "elarianThroneRoom",
    x: 4,
    y: 1,
    name: "Jeffrey",
    tileImage: "jesterJeffrey",
    dialogueKey: "jesterJeffrey",
    dialogueFunction: ()=>"jesterJeffrey.talk"
};
const $efd6490a4c2330eb$export$eacff79d149a9f38 = {
    npc: $efd6490a4c2330eb$var$npc,
    dialogues: $efd6490a4c2330eb$var$dialogues
};


const $2f32b09e2dbc0962$var$dialogues = {
    kingRehoboam: {
        greeting: {
            text: `"Ah, Cedric, my old friend! And Thaddeus, the hero of the hour. Welcome to both of you."`,
            next: "shopkeeperCedric.throneRoomWineDelivery"
        },
        wineResponse: {
            text: `"Cedric, your wine never disappoints. I look forward to savoring it. Now, I believe there's a more pressing matter at hand?"`,
            next: "kingRehoboam.crownRequest"
        },
        crownRequest: {
            text: `"Thaddeus, I understand you have retrieved something of great importance to me and this kingdom."`,
            options: [
                {
                    display: "Present the crown to the king",
                    text: `"Your Majesty, I have retrieved your crown from the Goblin King. It is my honor to return it to you."`,
                    next: "kingRehoboam.crownRequest.crownResponse"
                },
                {
                    display: "Present the crown to the king (informal)",
                    text: `"Yep! I got your crown back from the Goblin King. Here you go."`,
                    next: "kingRehoboam.crownRequest.crownResponse"
                }
            ],
            crownResponse: {
                text: `"My crown! You have done this kingdom a great service. You have my deepest gratitude. Now, the Goblin King is a crafty foe. Might I ask how you managed to retrieve it?"`,
                options: [
                    {
                        display: "Say that you defeated the Goblin King in combat",
                        text: `"It was a fierce battle, but I defeated the Goblin King in combat and took the crown from him."`,
                        next: "kingRehoboam.crownRequest.crownResponse.goblin"
                    },
                    {
                        display: "Say that you outsmarted the Goblin King",
                        text: `"I managed to convince him that the crown was cursed and he willingly gave it to me."`,
                        next: "kingRehoboam.crownRequest.crownResponse.goblin"
                    },
                    {
                        display: "Say that you made a deal with the Goblin King",
                        text: `"I offered him a trade for the crown, and he accepted."`,
                        next: "kingRehoboam.crownRequest.crownResponse.goblin"
                    }
                ],
                goblin: {
                    text: `"A cunning strategy. The Goblin King is not one to be underestimated. Now that you have my audience, is there anything else you wish to discuss?"`,
                    options: [
                        {
                            display: "Ask for the king's blessing on your quest",
                            text: `"Your Majesty, I seek your blessing on my quest to defeat The Dark One."`,
                            next: "kingRehoboam.crownRequest.crownResponse.goblin.questBlessing"
                        },
                        {
                            display: "Ask for the king's blessing on your quest (informal)",
                            text: `"Well, I was hoping you could give me your blessing on my quest to defeat The Dark One."`,
                            next: "kingRehoboam.crownRequest.crownResponse.goblin.questBlessing"
                        }
                    ],
                    questBlessing: {
                        text: `"A noble and perilous quest indeed. You have proven your valor in retrieving my crown. You have my full blessing. As it happens, we may have a plan that could aid you in this noble quest."`,
                        options: [
                            {
                                display: "Ask the king about the plan",
                                text: `"Thank you, Your Majesty. What is this plan you speak of?"`,
                                next: "kingRehoboam.crownRequest.crownResponse.goblin.questBlessing.plan"
                            },
                            {
                                display: "Ask the king about the plan (informal)",
                                text: `"Cool. What's the plan?"`,
                                next: "kingRehoboam.crownRequest.crownResponse.goblin.questBlessing.plan"
                            }
                        ],
                        plan: {
                            text: `"Our city wizard, Eldwin, has been working on a plan to defeat the Dark One. He believes he has found a way, but we needed a brave adventurer to carry it out. Your success in retrieving the crown proves you may be the one we've been waiting for."`,
                            options: [
                                {
                                    display: "Offer to meet with Eldwin about the plan",
                                    text: `"I would be honored to meet with Eldwin and learn about this plan, Your Majesty."`,
                                    next: "kingRehoboam.crownRequest.crownResponse.goblin.questBlessing.plan.directToEldwin"
                                },
                                {
                                    display: "Ask the king for more information about the plan",
                                    text: `"What is this plan that Eldwin has devised?"`,
                                    next: "kingRehoboam.crownRequest.crownResponse.goblin.questBlessing.plan.details"
                                }
                            ],
                            directToEldwin: {
                                text: `"Excellent! Eldwin resides in the wizard's tower in the eastern part of our fair city of Elarian. Seek him out, and he will provide you with the details of the plan. May the light guide your path, Thaddeus."`,
                                next: "kingRehoboam.audienceConclusion"
                            },
                            details: {
                                text: `"I will leave the details to Eldwin. He resides in the wizard's tower in the eastern part of our fair city of Elarian. Seek him out, and he will provide you with the details of the plan. May the light guide your path, Thaddeus."`,
                                next: "kingRehoboam.audienceConclusion"
                            }
                        }
                    }
                }
            }
        },
        audienceConclusion: {
            text: `"You have both served the kingdom well today. Cedric, I look forward to enjoying your fine wine. Thaddeus, may your future endeavors be as successful as this one. You are always welcome in my court."`,
            next: "shopkeeperCedric.throneRoomDeparture"
        },
        talk: {
            text: `"Greetings, Thaddeus. Thank you for returning my crown. You have done this kingdom a great service."`
        }
    }
};
const $2f32b09e2dbc0962$var$npc = {
    type: "npc",
    location: "elarianThroneRoom",
    x: 2,
    y: 5,
    name: "King Rehoboam",
    tileImage: "king",
    dialogueKey: "kingRehoboam",
    dialogueFunction: ()=>"kingRehoboam.talk"
};
const $2f32b09e2dbc0962$export$a9612130d3e26c01 = {
    npc: $2f32b09e2dbc0962$var$npc,
    dialogues: $2f32b09e2dbc0962$var$dialogues
};






const $b657f5b28ad69c46$var$dialogues = {
    castleGuard: {
        talk: {
            text: `"Halt! Who are you and what is your business in the castle?"`,
            options: [
                {
                    display: "Give your name and tell him why you are here",
                    text: `"I am Thaddeus, son of Bartholomew. I am here to seek an audience with the king. I would like his blessing on my quest to defeat The Dark One."`,
                    next: "castleGuard.talk.seeTheKing"
                },
                {
                    display: "Use a fake identity and try to convince him to let you in",
                    text: `"I am a merchant from the far east. I have come to deliver a special gift to the king."`,
                    next: "castleGuard.talk.convinceGuard"
                }
            ],
            seeTheKing: {
                text: `"Welcome to the castle, Thaddeus. I'm sorry, but I can't let you in. Only those with a personal invitation from the king may enter the throne room."`
            },
            convinceGuard: {
                text: `"You say you have a gift for the king? What is it?"`,
                options: [
                    {
                        display: "Tell him you have a rare jewel",
                        text: `"I have a rare jewel that is said to bring good luck to those who possess it. I would like to present it to the king as a token of my respect."`,
                        next: "castleGuard.talk.convinceGuard.deliveryAttempt"
                    },
                    {
                        display: "Tell him you have a magical artifact",
                        text: `"I have a magical artifact that is said to have been created by the gods themselves. I would like to present it to the king as a token of my respect."`,
                        next: "castleGuard.talk.convinceGuard.deliveryAttempt"
                    }
                ],
                deliveryAttempt: {
                    text: `"Wow! That is quite impressive. I will have to take a look at it before I can let you in. Please hand it over."`,
                    options: [
                        {
                            display: "Tell him that it needs to be delivered in person",
                            text: `"I'm sorry, but only I can deliver this gift to the king. It is of the utmost importance that I present it to him myself."`,
                            next: "castleGuard.talk.convinceGuard.deliveryAttempt.refusal"
                        },
                        {
                            display: "Give him something from your pocket",
                            text: `"Alright, here you go."`,
                            next: "castleGuard.talk.convinceGuard.deliveryAttempt.giveRock"
                        }
                    ],
                    refusal: {
                        text: `"I'm sorry, but I can't let you in. Those are the rules. If you can't hand it over, I can't help you."`
                    },
                    giveRock: {
                        text: `"What is this? A rock? Is this some kind of joke? I'm sorry, but I can't let you in. Those are the rules."`
                    }
                }
            }
        },
        noEntry: {
            text: `"I'm sorry, but only those with a personal invitation from the king may enter the throne room."`
        },
        noEntry2: {
            text: `"I'm sorry, but I can't let you in. Those are the rules."`
        },
        wineDelivery: {
            text: `"Ah, Cedric. It has been a while. How are you doing?"`,
            next: "shopkeeperCedric.wineDelivery"
        },
        wineDelivery2: {
            text: `"Glad to hear it! Why don't you hand it over? I will make sure the king gets it and will bring your payment to you later."`,
            next: "shopkeeperCedric.wineDelivery2"
        },
        wineDelivery3: {
            text: `"I'm sorry, but you know the law. Only those with a personal invitation from the king may enter the throne room."`,
            next: "shopkeeperCedric.wineDelivery3"
        },
        wineDelivery4: {
            text: `"Hmmm... You said your friend took care of the rat boss? Do you think he would be able to help me with something?"`,
            next: "shopkeeperCedric.wineDelivery4"
        },
        askForCrown: {
            text: `"The Goblin King stole the king's crown and I need someone to get it back. If he can do that, I will let you both in."`,
            options: [
                {
                    display: "Offer to help",
                    text: `"Alright, I can do that for you. Where can I find the Goblin King?"`,
                    next: "castleGuard.askForCrown.goblinKingAccept"
                },
                {
                    display: "Ask for payment",
                    text: `"I could do that for you, but I will need some payment for my services."`,
                    next: "castleGuard.askForCrown.goblinKingPayment"
                },
                {
                    display: "Ask why he can't do it himself",
                    text: `"Why can't you do it yourself? Isn't that your job?"`,
                    next: "castleGuard.askForCrown.goblinKingWhy"
                }
            ],
            goblinKingAccept: {
                text: `"The Goblin King is in the forest to the west of the castle's courtyard in the north. Good luck!"`,
                next: "shopkeeperCedric.wineDelivery5",
                function: ()=>{
                    (0, $846df9480552348c$export$17b07c660794dc13).unlockEntrance("elarianCourtyard", "goblinForestBottom2");
                }
            },
            goblinKingPayment: {
                text: `"Is an audience with the king not payment enough for you? I'm sorry, but I can't help you if you won't help me."`,
                options: [
                    {
                        display: "Offer to help",
                        text: `"Alright, I can do that for you. Where can I find the Goblin King?"`,
                        next: "castleGuard.askForCrown.goblinKingAccept"
                    }
                ]
            },
            goblinKingWhy: {
                text: `"The Goblin King is too powerful for me to defeat. You were able to take care of the rat boss, so I thought you might be able to help."`,
                options: [
                    {
                        display: "Offer to help",
                        text: `"Alright, I can do that for you. Where can I find the Goblin King?"`,
                        next: "castleGuard.askForCrown.goblinKingAccept"
                    },
                    {
                        display: "Ask for payment",
                        text: `"I could do that for you, but I will need some payment for my services."`,
                        next: "castleGuard.askForCrown.goblinKingPayment"
                    }
                ]
            }
        },
        goblinKing: {
            text: `"I once saw the Goblin King. He was terrifying and ugly. I hope you can defeat him!"`
        },
        goblinKing2: {
            text: `"The Goblin King is in the forest to the west of the castle's courtyard in the north. Good luck!"`
        },
        talkToOtherGuard: {
            text: `"I'm just an intern, you should talk to the other guard."`
        },
        crownDeliveryNoCedric: {
            text: `"You've retrieved the crown? That's excellent! But wait, where's Cedric? He was supposed to accompany you. You should go get him first."`,
            options: [
                {
                    display: "Go get Cedric",
                    text: `"You're right, I'll go get him now."`
                },
                {
                    display: "Insist on delivering the crown now",
                    text: `"But I have the crown right here. Can't we just deliver it now?"`,
                    next: "castleGuard.crownDeliveryNoCedric.insist"
                }
            ],
            insist: {
                text: `"I'm sorry, but Cedric was instrumental in this whole affair. It wouldn't be right to leave him out. Please go fetch him from his shop."`
            }
        },
        crownDeliveryNoCedricNoOptions: {
            text: `"Please go fetch Cedric from his shop. He was instrumental in this whole affair and it wouldn't be right to leave him out."`
        },
        crownDeliveryWithCedric: {
            text: `"You've retrieved the crown? Excellent work! Please, both of you, follow me to the throne room."`,
            next: "castleGuard.throneRoomIntroduction",
            continueFunction: async ()=>{
                // Move castle guard to the throne room.
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Castle Guard 2", "elarianCastle", "elarianThroneRoom", 1, 2);
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                // Move Cedric to the throne room.
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCastle", "Cedric", "right");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCastle", "Cedric", "up");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(500);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Cedric", "elarianCastle", "elarianThroneRoom", 3, 2);
                // Move player to the throne room.
                await (0, $846df9480552348c$export$17b07c660794dc13).movePlayerTap((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation, 2, 5, true);
                await (0, $846df9480552348c$export$17b07c660794dc13).movePlayerTap("elarianThroneRoom", 2, 2, true);
            }
        },
        throneRoomIntroduction: {
            text: `"Your Majesty, I present to you Cedric, the wine merchant, and Thaddeus, the brave adventurer who retrieved your crown."`,
            next: "kingRehoboam.greeting",
            continueFunction: async ()=>{
                // Move the guard to the right of his original position.
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianThroneRoom", "Castle Guard 2", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianThroneRoom", "Castle Guard 2", "right");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Castle Guard 2", "elarianThroneRoom", "elarianCastle", 3, 4);
            }
        },
        afterCrown1: {
            text: `"Once I am done with my internship, I will be a full-fledged guard. I can't wait!"`
        },
        afterCrown2: {
            text: `"Thanks again for getting the crown back. You're always welcome in the castle."`
        }
    }
};
const $b657f5b28ad69c46$var$getDefaultDialogue = ()=>{
    if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopkeeperCedric.talk.cedricWine") && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.wineDelivery")) return "castleGuard.wineDelivery";
    else if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.wineDelivery") && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.talk")) return "castleGuard.talk";
};
const $b657f5b28ad69c46$var$npcs = [
    {
        type: "npc",
        location: "elarianCastle",
        x: 1,
        y: 4,
        name: "Castle Guard 1",
        displayName: "Castle Guard",
        tileImage: "guard",
        dialogueKey: "castleGuard",
        dialogueFunction: ()=>{
            const defaultDialogue = $b657f5b28ad69c46$var$getDefaultDialogue();
            if (defaultDialogue) return defaultDialogue;
            else if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.find((item)=>item.name === "King's Crown") && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.crownDeliveryWithCedric")) return "castleGuard.talkToOtherGuard";
            else if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.wineDelivery")) return "castleGuard.noEntry";
            else if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.crownDeliveryWithCedric")) return "castleGuard.goblinKing";
            else return "castleGuard.afterCrown1";
        }
    },
    {
        type: "npc",
        location: "elarianCastle",
        x: 2,
        y: 4,
        name: "Castle Guard 2",
        displayName: "Castle Guard",
        tileImage: "guard",
        dialogueKey: "castleGuard",
        // Shares dialogues with Castle Guard 1, since they have the same display name.
        dialogueFunction: ()=>{
            const defaultDialogue = $b657f5b28ad69c46$var$getDefaultDialogue();
            if (defaultDialogue) return defaultDialogue;
            else if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.find((item)=>item.name === "King's Crown") && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.crownDeliveryWithCedric")) {
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("shopkeeperCedric.talk.gotCrown")) {
                    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.crownDeliveryNoCedric")) return "castleGuard.crownDeliveryNoCedric";
                    else return "castleGuard.crownDeliveryNoCedricNoOptions";
                } else return "castleGuard.crownDeliveryWithCedric";
            } else if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.wineDelivery")) return "castleGuard.noEntry2";
            else if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("castleGuard.crownDeliveryWithCedric")) return "castleGuard.goblinKing2";
            else return "castleGuard.afterCrown2";
        }
    }
];
const $b657f5b28ad69c46$export$d2ed7535fb016412 = {
    npcs: $b657f5b28ad69c46$var$npcs,
    dialogues: $b657f5b28ad69c46$var$dialogues
};


const $89fc7597e427d5e3$var$dialogues = {
    kingGuard: {
        talk1: {
            text: `"Welcome to the throne room. Please show respect in the presence of His Majesty."`
        },
        talk2: {
            text: `"It's an honor to stand in the presence of the hero who retrieved the king's crown. Your bravery brings hope to our kingdom."`
        }
    }
};
const $89fc7597e427d5e3$var$npcs = [
    {
        type: "npc",
        location: "elarianThroneRoom",
        x: 1,
        y: 5,
        name: "King's Guard 1",
        displayName: "King's Guard",
        tileImage: "guard",
        dialogueKey: "kingGuard",
        dialogueFunction: ()=>"kingGuard.talk1"
    },
    {
        type: "npc",
        location: "elarianThroneRoom",
        x: 3,
        y: 5,
        name: "King's Guard 2",
        displayName: "King's Guard",
        tileImage: "guard",
        dialogueKey: "kingGuard",
        dialogueFunction: ()=>"kingGuard.talk2"
    }
];
const $89fc7597e427d5e3$export$46a8a97cdf9f82ed = {
    npcs: $89fc7597e427d5e3$var$npcs,
    dialogues: $89fc7597e427d5e3$var$dialogues
};




const $334d810d48859da0$var$dialogues = {
    elarianGuard: {
        talk: {
            text: `"Halt! Who are you and what brings you to the city of the great king?"`,
            options: [
                {
                    display: "Give your name and tell him your true purpose",
                    text: `"I am Thaddeus, son of Bartholomew. I am here to seek an audience with the king. I would like his blessing on my quest to defeat The Dark One."`,
                    next: "elarianGuard.talk.seeTheKing"
                },
                {
                    display: "Give a fake name and say you are a tourist",
                    text: `"I am Coriander, son of Terrence. I am a traveller from Adria visiting Glenfall for the first time. I have heard about the beauty of Elarian and would like to see it for myself."`,
                    next: "elarianGuard.talk.seeTheCity"
                }
            ],
            seeTheKing: {
                text: `"Ah, nice to meet you, Thaddeus. Welcome to Elarian! If you are looking to speak with the king, you might want to talk with the shopkeeper, Cedric, first. He knows the king well and might be able to help you."`,
                function: ()=>{
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianGates", "Elarian Guard 2", "right");
                }
            },
            seeTheCity: {
                text: `"Hmm... You look a lot like a Glenfallian. Anyways, nice to meet you, Coriander. Welcome to Elarian! If you are looking to explore the city, I recommend you start at the cathedral. It is the most beautiful building in the city."`,
                function: ()=>{
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianGates", "Elarian Guard 2", "right");
                }
            }
        },
        postIntro: {
            text: `"Have a great time in Elarian!"`
        },
        postIntro2: {
            text: `"Hope you find what you're looking for in Elarian!"`
        }
    }
};
const $334d810d48859da0$var$getDefaultDialogue = ()=>{
    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("elarianGuard.talk")) return "elarianGuard.talk";
    else return;
};
const $334d810d48859da0$var$npcs = [
    {
        type: "npc",
        location: "elarianGates",
        x: 1,
        y: 4,
        name: "Elarian Guard 1",
        displayName: "Elarian Guard",
        tileImage: "guard",
        dialogueKey: "elarianGuard",
        dialogueFunction: ()=>{
            const defaultDialogue = $334d810d48859da0$var$getDefaultDialogue();
            if (defaultDialogue) return defaultDialogue;
            else return "elarianGuard.postIntro";
        }
    },
    {
        type: "npc",
        location: "elarianGates",
        x: 2,
        y: 4,
        name: "Elarian Guard 2",
        displayName: "Elarian Guard",
        tileImage: "guard",
        dialogueKey: "elarianGuard",
        // Shares dialogues with Elarian Guard 1, since they have the same display name.
        dialogueFunction: ()=>{
            const defaultDialogue = $334d810d48859da0$var$getDefaultDialogue();
            if (defaultDialogue) return defaultDialogue;
            else return "elarianGuard.postIntro2";
        }
    }
];
const $334d810d48859da0$export$a4890242ccad2743 = {
    npcs: $334d810d48859da0$var$npcs,
    dialogues: $334d810d48859da0$var$dialogues
};




const $84705d551e512480$var$dialogues = {
    courtyardGuard: {
        lockedForest: {
            text: `"The forest is too dangerous for civilians. I can't let you pass until you have the proper authorization."`,
            prefunction: async ()=>{
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "up");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "up");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "up");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "up");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "right");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
            },
            function: async ()=>{
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "left");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "down");
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("elarianCourtyard", "Courtyard Guard 1", "down");
            }
        },
        greeting1: {
            text: `"Hey there! Welcome to the Elarian Courtyard. It's a beautiful day, isn't it?"`
        },
        greeting2: {
            text: `"Hello! Don't forget to take a look at the statue in the center of the courtyard. I hear it's magical."`
        }
    }
};
const $84705d551e512480$var$getDefaultDialogue = ()=>{
    return;
};
const $84705d551e512480$var$npcs = [
    {
        type: "npc",
        location: "elarianCourtyard",
        x: 2,
        y: 1,
        name: "Courtyard Guard 1",
        displayName: "Courtyard Guard",
        tileImage: "guard",
        dialogueKey: "courtyardGuard",
        dialogueFunction: ()=>{
            const defaultDialogue = $84705d551e512480$var$getDefaultDialogue();
            if (defaultDialogue) return defaultDialogue;
            else return "courtyardGuard.greeting1";
        }
    },
    {
        type: "npc",
        location: "elarianCourtyard",
        x: 4,
        y: 1,
        name: "Courtyard Guard 2",
        displayName: "Courtyard Guard",
        tileImage: "guard",
        dialogueKey: "courtyardGuard",
        // Shares dialogues with Courtyard Guard 1, since they have the same display name.
        dialogueFunction: ()=>{
            const defaultDialogue = $84705d551e512480$var$getDefaultDialogue();
            if (defaultDialogue) return defaultDialogue;
            else return "courtyardGuard.greeting2";
        }
    }
];
const $84705d551e512480$export$3c41bde73692e1e = {
    npcs: $84705d551e512480$var$npcs,
    dialogues: $84705d551e512480$var$dialogues
};


const $36e032df35775408$var$dialogues = {
    ...(0, $b657f5b28ad69c46$export$d2ed7535fb016412).dialogues,
    ...(0, $89fc7597e427d5e3$export$46a8a97cdf9f82ed).dialogues,
    ...(0, $334d810d48859da0$export$a4890242ccad2743).dialogues,
    ...(0, $84705d551e512480$export$3c41bde73692e1e).dialogues
};
const $36e032df35775408$var$npcList = [
    ...(0, $b657f5b28ad69c46$export$d2ed7535fb016412).npcs,
    ...(0, $89fc7597e427d5e3$export$46a8a97cdf9f82ed).npcs,
    ...(0, $334d810d48859da0$export$a4890242ccad2743).npcs,
    ...(0, $84705d551e512480$export$3c41bde73692e1e).npcs
];
const $36e032df35775408$export$f3249297f3edf7e9 = {
    npcList: $36e032df35775408$var$npcList,
    dialogues: $36e032df35775408$var$dialogues
};








let $d9775c0412d7d5fd$var$currentCombat = undefined;
const $d9775c0412d7d5fd$var$getAttackOptions = ()=>{
    return [
        {
            display: "Physical Attack",
            ...$d9775c0412d7d5fd$var$baseAttackOption("physical")
        },
        ...(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp >= 3 && !(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hideMagic ? [
            {
                display: "Magic Attack",
                ...$d9775c0412d7d5fd$var$baseAttackOption("magic")
            }
        ] : [],
        ...(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.filter((item)=>item.type === "combatItem").length > 0 ? [
            {
                display: "Use Item",
                next: "goblinForest.items"
            }
        ] : []
    ];
};
const $d9775c0412d7d5fd$var$baseAttackOption = (attackType)=>{
    return {
        function: async ()=>{
            (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons();
            $d9775c0412d7d5fd$var$attack(attackType);
            await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText($d9775c0412d7d5fd$var$currentCombat.player.attackMessage);
            $d9775c0412d7d5fd$var$currentCombat.enemy.updateHealthBarFunction();
            await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(1000);
            if ($d9775c0412d7d5fd$var$currentCombat.enemy.lowHealthMessage) {
                await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText($d9775c0412d7d5fd$var$currentCombat.enemy.lowHealthMessage);
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(1000);
            }
            if ($d9775c0412d7d5fd$var$currentCombat.enemy.remainingHp > 0) {
                await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText($d9775c0412d7d5fd$var$currentCombat.enemy.attackMessage);
                $d9775c0412d7d5fd$var$currentCombat.player.updateHealthBarFunction();
                await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(1000);
                if ($d9775c0412d7d5fd$var$currentCombat.player.lowHealthMessage) {
                    await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText($d9775c0412d7d5fd$var$currentCombat.player.lowHealthMessage);
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(1000);
                }
            }
            if ($d9775c0412d7d5fd$var$currentCombat.enemy.remainingHp === 0) await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
                dialogueName: $d9775c0412d7d5fd$var$currentCombat.enemy.defeatDialogue,
                enemyDefeated: (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy
            });
            else if ($d9775c0412d7d5fd$var$currentCombat.player.remainingHp === 0) {
                // The player will wake up in the tower with full health.
                (0, $846df9480552348c$export$17b07c660794dc13).hideDisplay();
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
                    dialogueName: "elarianTower.faint"
                });
            } else {
                await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText("What will you do?");
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons($d9775c0412d7d5fd$var$getAttackOptions());
            }
            $d9775c0412d7d5fd$var$currentCombat = undefined;
        }
    };
};
const $d9775c0412d7d5fd$var$returnToMap = ()=>{
    const locationName = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).previousEnemy = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy;
    delete (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy;
    $d9775c0412d7d5fd$var$calculateTilesToEnemy();
    (0, $846df9480552348c$export$17b07c660794dc13).displayLocation(locationName);
    (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
};
const $d9775c0412d7d5fd$var$checkForCombat = ()=>{
    const thisLocation = (0, $846df9480552348c$export$17b07c660794dc13).locations.find((location)=>location.name === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
    if (!thisLocation.combat?.combatKey) return;
    const thisPlayerCombat = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).combat?.[thisLocation.combat.combatKey];
    if (!thisPlayerCombat) $d9775c0412d7d5fd$var$calculateTilesToEnemy();
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).combat[thisLocation.combat.combatKey].tilesToEnemy--;
    if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).combat[thisLocation.combat.combatKey].tilesToEnemy <= 0) {
        let enemies = thisLocation.combat.enemies;
        if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).previousEnemy) {
            const previousEnemyIndex = thisLocation.combat.enemies.findIndex((enemy)=>enemy.name === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).previousEnemy?.name);
            const remainingEnemies = thisLocation.combat.enemies.filter((enemy, index)=>index !== previousEnemyIndex);
            // Probability of encountering the previous enemy again is cut in half.
            enemies = [
                ...remainingEnemies,
                ...enemies
            ];
        }
        const randomEnemy = enemies[Math.floor(Math.random() * enemies.length)];
        (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy = {
            ...randomEnemy
        };
        return true;
    }
};
const $d9775c0412d7d5fd$var$calculateTilesToEnemy = ()=>{
    const thisLocation = (0, $846df9480552348c$export$17b07c660794dc13).locations.find((location)=>location.name === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
    if (!thisLocation.combat?.combatKey) return;
    // I had initially set the range to be 3-7, but it seemed too frequent. 4-7 seems to be a good balance.
    let minTilesToEnemy = 4;
    let maxTilesToEnemy = 7;
    // For larger maps, increase the range of tiles to the enemy to allow for more exploration without interruption.
    if (thisLocation.combat.encounterRate === "low") {
        minTilesToEnemy = 6;
        maxTilesToEnemy = 9;
    }
    // Get a random number of tiles to the enemy within the range.
    const tilesToEnemy = Math.floor(Math.random() * (maxTilesToEnemy - minTilesToEnemy + 1) + minTilesToEnemy);
    if (!(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).combat[thisLocation.combat.combatKey]) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).combat[thisLocation.combat.combatKey] = {};
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).combat[thisLocation.combat.combatKey].tilesToEnemy = tilesToEnemy;
};
const $d9775c0412d7d5fd$var$attack = (attackType)=>{
    const thisEnemy = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy;
    const playerAttack = $d9775c0412d7d5fd$var$calculateAttack((0, $bd94a79bfb1fb5b4$export$615455393ee443ca), thisEnemy, attackType);
    const enemyAttack = $d9775c0412d7d5fd$var$calculateAttack(thisEnemy, (0, $bd94a79bfb1fb5b4$export$615455393ee443ca), "physical");
    let playerRemainingHp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp - enemyAttack.damage;
    if (playerRemainingHp < 0) playerRemainingHp = 0;
    let enemyRemainingHp = thisEnemy.hp - playerAttack.damage;
    if (enemyRemainingHp < 0) enemyRemainingHp = 0;
    if (thisEnemy.name === "Rat Boss" && (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hideMagic && enemyRemainingHp === 0) {
        // The player should not be able to defeat the rat boss without using magic.
        enemyRemainingHp = thisEnemy.hp;
        playerAttack.isMiss = true;
    }
    if (attackType === "physical" && !playerAttack.isMiss) // Restore one magic point for every physical attack.
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp = Math.min((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp + 1, (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp);
    else if (attackType === "magic") // Magic attacks cost three magic points.
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp = Math.max((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp - 3, 0);
    (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateMagicBar();
    const playerMessageNumber = Math.floor(Math.random() * 3);
    let playerMessage = "";
    if (playerAttack.isMiss) playerMessage = $d9775c0412d7d5fd$var$attackMessages.miss[playerMessageNumber];
    else if (playerAttack.isCriticalHit) playerMessage = $d9775c0412d7d5fd$var$attackMessages.critical[playerMessageNumber];
    else playerMessage = $d9775c0412d7d5fd$var$attackMessages[attackType][playerMessageNumber];
    const enemyMessageNumber = Math.floor(Math.random() * 3);
    let enemyMessage = "";
    if (enemyAttack.isMiss) enemyMessage = $d9775c0412d7d5fd$var$attackMessages.enemyMiss[enemyMessageNumber];
    else if (enemyAttack.isCriticalHit) enemyMessage = $d9775c0412d7d5fd$var$attackMessages.enemyCritical[enemyMessageNumber];
    else enemyMessage = $d9775c0412d7d5fd$var$attackMessages.enemy[enemyMessageNumber];
    // Only show a low health message if their health is low for the first time.
    const playerLowHealth = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp / (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp > 0.3 && playerRemainingHp / (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp <= 0.3 && playerRemainingHp > 0;
    const enemyLowHealth = thisEnemy.hp / thisEnemy.maxHp > 0.3 && enemyRemainingHp / thisEnemy.maxHp <= 0.3 && enemyRemainingHp > 0;
    $d9775c0412d7d5fd$var$currentCombat = {
        player: {
            remainingHp: playerRemainingHp,
            attackMessage: playerMessage,
            lowHealthMessage: playerLowHealth ? $d9775c0412d7d5fd$var$attackMessages.lowHealth[Math.floor(Math.random() * 3)] : "",
            updateHealthBarFunction: ()=>{
                (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp = playerRemainingHp;
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateHealthBar();
            }
        },
        enemy: {
            remainingHp: enemyRemainingHp,
            attackMessage: enemyMessage,
            lowHealthMessage: enemyLowHealth ? $d9775c0412d7d5fd$var$attackMessages.enemyLowHealth[Math.floor(Math.random() * 3)] : "",
            updateHealthBarFunction: ()=>{
                thisEnemy.hp = enemyRemainingHp;
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateHealthBar("enemyHealthLevel", thisEnemy.hp, thisEnemy.maxHp);
            },
            defeatDialogue: thisEnemy.defeatDialogueFunction()
        }
    };
    // Replace the word "enemy" with the enemy's name in the enemy messages
    $d9775c0412d7d5fd$var$currentCombat.enemy.attackMessage = $d9775c0412d7d5fd$var$currentCombat.enemy.attackMessage.replace(thisEnemy.excludeThe ? "the enemy" : "enemy", thisEnemy.excludeThe ? thisEnemy.name : thisEnemy.name.toLowerCase());
    $d9775c0412d7d5fd$var$currentCombat.enemy.lowHealthMessage = $d9775c0412d7d5fd$var$currentCombat.enemy.lowHealthMessage.replace(thisEnemy.excludeThe ? "the enemy" : "enemy", thisEnemy.excludeThe ? thisEnemy.name : thisEnemy.name.toLowerCase());
};
const $d9775c0412d7d5fd$var$calculateAttack = (attackerStats, defenderStats, attackType)=>{
    const { attack: attack, magicAttack: magicAttack, level: level } = attackerStats;
    const { defense: defense, magicDefense: magicDefense } = defenderStats;
    const isMagicAttack = attackType === "magic";
    const relevantAttackStat = isMagicAttack ? magicAttack : attack;
    const relevantDefenseStat = isMagicAttack ? magicDefense : defense;
    // Critical hit calculation
    const baseCritChance = 0.1; // 10% base critical hit chance
    const isCriticalHit = Math.random() < baseCritChance;
    const critBonus = isCriticalHit ? 2 : 1;
    // Calculate base damage.
    const modifier = 2 * critBonus * level / 5 + 2;
    let damage = modifier * (relevantAttackStat / relevantDefenseStat) + 2;
    // Calculate damage variation (85% to 100% of base damage).
    const damageVariation = 0.15; // 15% variation
    const minDamage = Math.ceil(damage * (1 - damageVariation));
    damage = Math.ceil(Math.random() * (damage - minDamage + 1)) + minDamage;
    // Magic attack bonus (75% to 100% of damage)
    if (isMagicAttack) {
        const magicBonus = Math.ceil(damage * 0.75 + Math.random() * (damage * 0.25));
        damage += magicBonus;
    }
    // Miss calculation
    const baseMissChance = isMagicAttack ? 0 : 0.1; // 0% for magic, 10% for physical
    const isMiss = Math.random() < Math.max(0, baseMissChance);
    if (isMiss) return {
        damage: 0,
        isMiss: true,
        isCriticalHit: false
    };
    return {
        damage: Math.max(1, Math.floor(damage)),
        isMiss: false,
        isCriticalHit: isCriticalHit
    };
};
const $d9775c0412d7d5fd$var$attackMessages = {
    physical: [
        "You swing your sword mightily!",
        "A swift strike from your blade lands!",
        "You lunge forward with a quick attack!"
    ],
    magic: [
        "You cast a powerful fireball!",
        "A burst of lightning erupts from your hands!",
        "Mystic energies gather as you unleash a spell!"
    ],
    enemy: [
        "The enemy strikes back!",
        "A fierce blow from the enemy hits you!",
        "You feel a sharp pain as the enemy lands an attack!"
    ],
    critical: [
        "A devastating blow! You deal a critical hit!",
        "Critical hit! Your attack deals a massive blow!",
        "You hit a vital spot!"
    ],
    miss: [
        "You miss your attack.",
        "Your attack misses its mark!",
        "You swing and miss."
    ],
    enemyCritical: [
        "The enemy lands a critical hit!",
        "A critical hit from the enemy causes a massive blow!",
        "The enemy strikes a vital spot!"
    ],
    enemyMiss: [
        "The enemy misses its attack.",
        "The enemy swings and misses.",
        "The enemy attacks and misses."
    ],
    lowHealth: [
        "You are barely standing.",
        "You feel weak and exhausted.",
        "You're hanging on by a thread."
    ],
    enemyLowHealth: [
        "Your opponent is on the brink of defeat.",
        "The enemy struggles to stay standing.",
        "The enemy is barely holding on."
    ]
};
const $d9775c0412d7d5fd$export$d1fc4b468dcebbc2 = {
    getAttackOptions: $d9775c0412d7d5fd$var$getAttackOptions,
    returnToMap: $d9775c0412d7d5fd$var$returnToMap,
    checkForCombat: $d9775c0412d7d5fd$var$checkForCombat
};




const $e2f2497066d33e46$var$initiateCombat = ()=>{
    // Need to spread the npc object to avoid modifying the original object.
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy = {
        ...$e2f2497066d33e46$var$npc
    };
    (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("shopCellarBossRoom");
};
const $e2f2497066d33e46$var$dialogues = {
    ratBoss: {
        intro: {
            text: `"I am the rat boss! Welcome to my lair! What do you want?"`,
            options: [
                {
                    display: "Tell him to you are here for the wine",
                    text: `"Cedric sent me to get his wine from his cellar. This is not your lair."`,
                    next: "ratBoss.intro.wine"
                }
            ],
            wine: {
                text: `"Cedric sent you? That coward! I will not let you take the wine!"`,
                continueFunction: $e2f2497066d33e46$var$initiateCombat
            }
        },
        nextVisit: {
            text: `"You again? I thought I took care of you. Do you still want the wine?"`,
            options: [
                {
                    display: "Yes",
                    text: `"Yes, I am here for the wine. You won't be able to stop me this time."`,
                    continueFunction: $e2f2497066d33e46$var$initiateCombat
                }
            ]
        },
        encounter: {
            textFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("ratBoss.encounter")) return `"You will not leave this place alive!"`;
                return `"Prepare to meet your doom!"`;
            },
            next: "shopCellar.combat"
        },
        defeat: {
            text: `"No! How could I be defeated by a mere human? I will have my revenge!"`,
            options: [
                {
                    display: "Return to map",
                    function: ()=>(0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).returnToMap(),
                    next: "ratBoss.defeat.defeated"
                }
            ],
            defeated: {
                text: `"You have not seen the last of me. I will return stronger than ever!"`,
                function: async ()=>{
                    // The rat boss will walk out of the cellar.
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("shopCellarBossRoom", "Rat Boss", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("shopCellarBossRoom", "Rat Boss", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("shopCellarBossRoom", "Rat Boss", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpc("shopCellarBossRoom", "Rat Boss", "down");
                    await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(250);
                    (0, $846df9480552348c$export$17b07c660794dc13).moveNpcLocation("Rat Boss", "shopCellarBossRoom", "shopCellarBossRoom", -1, -1);
                }
            }
        }
    }
};
const $e2f2497066d33e46$var$npc = {
    type: "npc",
    location: "shopCellarBossRoom",
    x: 2,
    y: 5,
    name: "Rat Boss",
    tileImage: "ratBoss",
    dialogueKey: "ratBoss",
    dialogueFunction: ()=>{
        if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("ratBoss.intro")) return "ratBoss.intro";
        else return "ratBoss.nextVisit";
    },
    encounterDialogueFunction: ()=>"ratBoss.encounter",
    defeatDialogueFunction: ()=>"ratBoss.defeat",
    level: 3,
    hp: 40,
    maxHp: 40,
    attack: 30,
    magicAttack: 30,
    defense: 30,
    magicDefense: 15,
    gold: 25,
    boss: true
};
const $e2f2497066d33e46$export$fa00f50e84b0260a = {
    npc: $e2f2497066d33e46$var$npc,
    dialogues: $e2f2497066d33e46$var$dialogues
};






const $294ca2a9dfd90d7b$var$initiateCombat = ()=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy = {
        ...$294ca2a9dfd90d7b$var$npc
    };
    (0, $846df9480552348c$export$17b07c660794dc13).displayLocation((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
};
const $294ca2a9dfd90d7b$var$addCrownToInventory = ()=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.push({
        name: "King's Crown",
        type: "questItem"
    });
};
const $294ca2a9dfd90d7b$var$defaultOptions = [
    {
        requires: {
            not: "goblinKing.askNicely"
        },
        display: "Ask nicely for the crown",
        text: `"Might I humbly request the return of the king's crown, Goblin King?"`,
        next: "goblinKing.askNicely"
    },
    {
        requires: {
            not: "goblinKing.threaten"
        },
        display: "Threaten the Goblin King",
        text: `"If you don't hand over the crown willingly, I will take it by force."`,
        next: "goblinKing.threaten"
    },
    {
        requires: {
            not: "goblinKing.negotiate"
        },
        display: "Try to negotiate",
        text: `"Surely we can come to an agreement. What would you want in exchange for the crown?"`,
        next: "goblinKing.negotiate"
    },
    {
        requires: {
            not: "goblinKing.trick"
        },
        display: "Attempt to trick the Goblin King",
        text: `"Oh, mighty Goblin King! I've actually come to warn you. The crown is cursed and will bring great misfortune to any non-human who possesses it."`,
        next: "goblinKing.trick"
    },
    {
        display: "Fight the Goblin King",
        text: `"Prepare yourself, Goblin King. I will take the crown by force if I must."`,
        continueFunction: $294ca2a9dfd90d7b$var$initiateCombat
    }
];
const $294ca2a9dfd90d7b$var$dialogues = {
    goblinKing: {
        intro: {
            text: `"Well, well, well. What do we have here? A human daring to enter my tent?"`,
            options: [
                {
                    display: "Introduce yourself and state your purpose",
                    text: `"I am Thaddeus, son of Bartholomew. I've come for the king's crown you stole."`,
                    next: "goblinKing.introduce"
                }
            ]
        },
        secondEncounter: {
            text: `"Back again, human? You must have a death wish."`,
            options: $294ca2a9dfd90d7b$var$defaultOptions
        },
        introduce: {
            text: `"Oh, have you now? And what makes you think I'll just hand it over?"`,
            options: $294ca2a9dfd90d7b$var$defaultOptions
        },
        crownFromCombat: {
            text: `"You again? I thought I told you to get out of my sight."`
        },
        crownFromNegotiation: {
            text: `"Ah, Thaddeus. I hope you haven't forgotten our agreement."`
        },
        crownFromTrick: {
            text: `"I see you've returned. I trust you've kept your word? Is the curse broken?"`,
            options: [
                {
                    display: "Tell him you are still working on it",
                    text: `"I'm afraid the curse is proving more difficult to break than I anticipated."`,
                    next: "goblinKing.crownFromTrick.workingOnIt"
                },
                {
                    display: "Admit to failing",
                    text: `"I'm sorry, Goblin King. I have failed you. The curse remains unbroken."`,
                    next: "goblinKing.crownFromTrick.failed"
                },
                {
                    display: "Laugh and reveal the deception",
                    text: `"You seriously believed that nonsense about a curse? Ha! I was just trying to trick you."`,
                    next: "goblinKing.crownFromTrick.reveal"
                }
            ],
            workingOnIt: {
                text: `"I see. Well, I trust you will keep your word and continue to work on it."`
            },
            failed: {
                text: `"I see. Well, I suppose I should have expected as much from a human."`
            },
            reveal: {
                text: `"You dare deceive me, human? You will pay dearly for this."`,
                continueFunction: $294ca2a9dfd90d7b$var$initiateCombat
            }
        },
        askNicely: {
            text: `"You think you can just ask for the crown and I'll hand it over?"`,
            options: [
                {
                    display: "Yes...",
                    text: `"Well, yes. That was the idea."`,
                    next: "goblinKing.askNicely.yes"
                },
                {
                    display: "No...",
                    text: `"No, I suppose not. It was worth a try though."`,
                    next: "goblinKing.askNicely.no"
                }
            ],
            yes: {
                text: `"You humans are all the same. You think you can just ask for whatever you want and it will be given to you."`,
                options: $294ca2a9dfd90d7b$var$defaultOptions
            },
            no: {
                text: `"You're not as foolish as you look, human. But you're still not leaving here with the crown."`,
                options: $294ca2a9dfd90d7b$var$defaultOptions
            }
        },
        threaten: {
            text: `"You dare threaten me in my own domain? I am the Goblin King!"`,
            options: [
                {
                    display: "Stand your ground",
                    text: `"I stand by my words, Goblin King. Hand over the crown or face the consequences."`,
                    next: "goblinKing.threaten.standGround"
                },
                {
                    display: "Apologize and try a different approach",
                    text: `"I apologize for my rashness, Your Majesty. Perhaps we can discuss this civilly?"`,
                    next: "goblinKing.threaten.apologize"
                }
            ],
            standGround: {
                text: `"Then prepare to face me in combat, human. Let's see if you can back up your words with action."`,
                continueFunction: $294ca2a9dfd90d7b$var$initiateCombat
            },
            apologize: {
                text: `"So, the human can be reasonable after all. Speak, but choose your words carefully."`,
                options: $294ca2a9dfd90d7b$var$defaultOptions
            }
        },
        negotiate: {
            text: `"Interesting... I might consider a trade. But it would have to be something of great value."`,
            options: [
                {
                    display: "Offer gold",
                    text: `"I could pay you for it. How much would you want?"`,
                    next: "goblinKing.negotiate.gold"
                },
                {
                    display: "Suggest a personal favor",
                    text: `"Instead of material wealth, I offer you a favor. Anything within my power to grant, to be called upon at your discretion."`,
                    next: "goblinKing.negotiate.favor"
                },
                {
                    display: "Nevermind",
                    text: `"Maybe we won't be able to come to an agreement after all."`,
                    next: "goblinKing.negotiate.retract"
                }
            ],
            gold: {
                text: `"Ha! You think I care about your gold? You are going to have to do better than that."`,
                options: [
                    {
                        display: "Suggest a personal favor",
                        text: `"Instead of material wealth, I offer you a favor. Anything within my power to grant, to be called upon at your discretion."`,
                        next: "goblinKing.negotiate.favor"
                    },
                    {
                        display: "Nevermind",
                        text: `"Maybe we won't be able to come to an agreement after all."`,
                        next: "goblinKing.negotiate.retract"
                    }
                ]
            },
            favor: {
                text: `"A blank check, eh? That's a dangerous offer, human. Are you sure you want to make it?"`,
                options: [
                    {
                        display: "Confirm the offer",
                        text: `"I swear on my honor, I will grant you any favor you ask of me."`,
                        next: "goblinKing.negotiate.favor.confirm"
                    },
                    {
                        display: "Retract the offer and suggest something else",
                        text: `"On second thought, perhaps we can come to a different arrangement."`,
                        next: "goblinKing.negotiate.retract"
                    }
                ],
                confirm: {
                    text: `"Very well. I will hold you to your word, human. You can have the crown."`,
                    options: [
                        {
                            display: "Accept the crown",
                            text: `"Thank you, Goblin King. I will not forget your generosity."`,
                            next: "goblinKing.negotiate.favor.confirm.accept"
                        }
                    ],
                    accept: {
                        text: `"You are free to go, Thaddeus. But remember, I will call upon you when the time comes."`,
                        function: $294ca2a9dfd90d7b$var$addCrownToInventory
                    }
                }
            },
            retract: {
                text: `"You are testing my patience, human. I suggest you choose your next words carefully."`,
                options: $294ca2a9dfd90d7b$var$defaultOptions
            }
        },
        trick: {
            text: `"A curse, you say? Hmm... You could be lying to trick me."`,
            options: [
                {
                    display: 'Offer to "break" the curse',
                    text: `"Fear not, for I have the power to break this curse. But I'll need the crown to do it."`,
                    next: "goblinKing.trick.break"
                },
                {
                    display: "Admit to the deception and try a new approach",
                    text: `"You're right. I was trying to deceive you. But now I see that honesty might be the better path."`,
                    next: "goblinKing.trick.admit"
                }
            ],
            break: {
                text: `"You can break the curse? And I suppose you'll just return the crown once you've done so?"`,
                options: [
                    {
                        display: "Promise to return it",
                        text: `"I swear on my honor, I will return the crown to you once the curse is broken."`,
                        next: "goblinKing.trick.break.promise"
                    },
                    {
                        display: "Admit to the deception and try a new approach",
                        text: `"You're right. I was trying to deceive you. But now I see that honesty might be the better path."`,
                        next: "goblinKing.trick.admit"
                    }
                ],
                promise: {
                    text: `"Very well. You may take the crown and break the curse. But remember, I will be watching."`,
                    function: $294ca2a9dfd90d7b$var$addCrownToInventory
                }
            },
            admit: {
                text: `"You dare deceive me, human? You will pay dearly for this."`,
                continueFunction: $294ca2a9dfd90d7b$var$initiateCombat
            }
        },
        encounter: {
            text: `"I had a human for breakfast this morning. You'll make a fine lunch."`,
            next: "goblinForest.combat"
        },
        defeat: {
            text: `"Impossible! How could a mere human defeat the mighty Goblin King?"`,
            options: [
                {
                    display: "Return to map",
                    function: ()=>(0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).returnToMap(),
                    next: "goblinKing.defeat.defeated"
                }
            ],
            defeated: {
                text: `"You may have won this battle, but the war is far from over. Here, take your crown and leave my sight."`,
                function: $294ca2a9dfd90d7b$var$addCrownToInventory
            }
        }
    }
};
const $294ca2a9dfd90d7b$var$npc = {
    type: "npc",
    location: "goblinCamp",
    x: 2,
    y: 5,
    name: "Goblin King",
    tileImage: "goblinKing",
    dialogueKey: "goblinKing",
    dialogueFunction: ()=>{
        if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinKing.intro")) return "goblinKing.intro";
        if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinKing.defeat.defeated")) return "goblinKing.crownFromCombat";
        if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinKing.negotiate.favor.confirm.accept")) return "goblinKing.crownFromNegotiation";
        if ((0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("goblinKing.trick.break.promise")) return "goblinKing.crownFromTrick";
        return "goblinKing.secondEncounter";
    },
    encounterDialogueFunction: ()=>"goblinKing.encounter",
    defeatDialogueFunction: ()=>"goblinKing.defeat",
    level: 15,
    hp: 85,
    maxHp: 85,
    attack: 50,
    magicAttack: 50,
    defense: 50,
    magicDefense: 30,
    gold: 100,
    boss: true
};
const $294ca2a9dfd90d7b$export$fd60f5dc9db136ff = {
    npc: $294ca2a9dfd90d7b$var$npc,
    dialogues: $294ca2a9dfd90d7b$var$dialogues
};


const $e8e2a9a8961837c5$var$dialogues = {
    goblin: {
        goblin1: {
            text: `"I am a goblin. I am not your friend."`
        },
        goblin2: {
            text: `"Our king is the strongest of all goblins. You will never defeat him."`
        },
        goblin3: {
            text: `"We are the goblins. We are the best."`
        },
        goblin4: {
            text: `"I hope you are not here to challenge our king."`
        },
        goblin5: {
            text: `"I am watching you."`
        },
        goblin6: {
            text: `"You will never defeat our king."`
        },
        goblin7: {
            text: `"You are not welcome here."`
        },
        goblin8: {
            text: `"My name is Goblin. I am the best."`
        }
    }
};
const $e8e2a9a8961837c5$var$baseGoblin = {
    type: "npc",
    location: "goblinCamp",
    x: 0,
    y: 1,
    name: "Goblin 1",
    displayName: "Goblin",
    tileImage: "goblin",
    dialogueKey: "goblin",
    dialogueFunction: ()=>"goblin.goblin1"
};
const $e8e2a9a8961837c5$var$coordsList = [
    {
        x: 0,
        y: 1
    },
    {
        x: 0,
        y: 2
    },
    {
        x: 0,
        y: 3
    },
    {
        x: 0,
        y: 4
    },
    {
        x: 4,
        y: 1
    },
    {
        x: 4,
        y: 2
    },
    {
        x: 4,
        y: 3
    },
    {
        x: 4,
        y: 4
    }
];
const $e8e2a9a8961837c5$var$npcs = [];
for(let i = 0; i < 8; i++){
    const goblin = {
        ...$e8e2a9a8961837c5$var$baseGoblin
    };
    goblin.name = `Goblin ${i + 1}`;
    goblin.dialogueFunction = ()=>`goblin.goblin${i + 1}`;
    goblin.x = $e8e2a9a8961837c5$var$coordsList[i].x;
    goblin.y = $e8e2a9a8961837c5$var$coordsList[i].y;
    $e8e2a9a8961837c5$var$npcs.push(goblin);
}
const $e8e2a9a8961837c5$export$905d098731ecd158 = {
    npcs: $e8e2a9a8961837c5$var$npcs,
    dialogues: $e8e2a9a8961837c5$var$dialogues
};





const $747834922485a36a$var$shopItems = [
    {
        name: "magicPotion",
        displayName: "small magic potion",
        price: 50,
        text: `"The small magic potion will restore up to 9 magic points."`,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.push({
                name: "Small Magic Potion",
                type: "combatItem",
                uses: 1,
                useDialogue: "goblinForest.smallMagicPotion"
            });
        }
    },
    {
        name: "healthPotion",
        displayName: "small health potion",
        price: 50,
        text: `"The small health potion will restore up to 50 health points."`,
        buyFunction: ()=>{
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.push({
                name: "Small Health Potion",
                type: "combatItem",
                uses: 1,
                useDialogue: "goblinForest.smallHealthPotion"
            });
        }
    }
];
const $747834922485a36a$var$dialogues = {
    witchHazel: {
        talk: {
            textFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("witchHazel.talk")) return `"Welcome to my hut, traveler. I am Hazel. How can I help you?"`;
                return `"Is there anything I can help you with?"`;
            },
            options: [
                {
                    requires: {
                        not: "witchHazel.talk.about"
                    },
                    display: "Ask about Hazel",
                    text: `"Can you tell me more about yourself, Hazel?"`,
                    next: "witchHazel.talk.about"
                },
                {
                    display: "Ask for a potion",
                    text: `"Do you have any potions for sale?"`,
                    next: "witchHazel.talk.buy"
                },
                {
                    display: "Nevermind",
                    function: ()=>{
                        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
                    }
                }
            ],
            about: {
                text: `"I have been brewing potions in the great tree of Mirewood for many years. For a small fee, I can brew you a potion to help you on your journey."`
            },
            ...(0, $99a1b7580a9713be$export$7408eeab301af673)($747834922485a36a$var$shopItems, "witchHazel")
        }
    }
};
const $747834922485a36a$var$npc = {
    type: "npc",
    location: "witchHut",
    x: 2,
    y: 4,
    name: "Hazel",
    tileImage: "witch",
    dialogueKey: "witchHazel",
    dialogueFunction: ()=>"witchHazel.talk"
};
const $747834922485a36a$export$d898d4936dd57bf3 = {
    npc: $747834922485a36a$var$npc,
    dialogues: $747834922485a36a$var$dialogues
};


const $bc4efe90a4dcd3ee$var$dialogues = {
    ...(0, $e8cb25eed9e12d69$export$2896fb787da8416d).dialogues,
    ...(0, $6d8b15a0bbbd9e23$export$aad27058eca608a).dialogues,
    ...(0, $9b12285638816587$export$95524992ae3478c8).dialogues,
    ...(0, $efd6490a4c2330eb$export$eacff79d149a9f38).dialogues,
    ...(0, $2f32b09e2dbc0962$export$a9612130d3e26c01).dialogues,
    ...(0, $e2f2497066d33e46$export$fa00f50e84b0260a).dialogues,
    ...(0, $36e032df35775408$export$f3249297f3edf7e9).dialogues,
    ...(0, $294ca2a9dfd90d7b$export$fd60f5dc9db136ff).dialogues,
    ...(0, $e8e2a9a8961837c5$export$905d098731ecd158).dialogues,
    ...(0, $747834922485a36a$export$d898d4936dd57bf3).dialogues
};
const $bc4efe90a4dcd3ee$var$npcList = [
    (0, $e8cb25eed9e12d69$export$2896fb787da8416d).npc,
    (0, $6d8b15a0bbbd9e23$export$aad27058eca608a).npc,
    (0, $9b12285638816587$export$95524992ae3478c8).npc,
    (0, $efd6490a4c2330eb$export$eacff79d149a9f38).npc,
    (0, $2f32b09e2dbc0962$export$a9612130d3e26c01).npc,
    ...(0, $36e032df35775408$export$f3249297f3edf7e9).npcList,
    (0, $e2f2497066d33e46$export$fa00f50e84b0260a).npc,
    (0, $294ca2a9dfd90d7b$export$fd60f5dc9db136ff).npc,
    ...(0, $e8e2a9a8961837c5$export$905d098731ecd158).npcs,
    (0, $747834922485a36a$export$d898d4936dd57bf3).npc
];
const $bc4efe90a4dcd3ee$export$51aacac15ce329c4 = {
    npcList: $bc4efe90a4dcd3ee$var$npcList,
    dialogues: $bc4efe90a4dcd3ee$var$dialogues
};



const $846df9480552348c$var$locations = [
    ...(0, $2ac8cee356f0b1a5$export$4f83c5df3c20ecda),
    ...(0, $5216997f1c89315d$export$26362de1d76de1f2),
    ...(0, $9777b809b07ee19a$export$ca97b1f169fe524a)
];
let $846df9480552348c$var$isMoving = false;
var $c5175b3dbfa61bab$exports = {};
$c5175b3dbfa61bab$exports = new URL("cobblestone.25f8742f.webp", import.meta.url).toString();


var $2e55afe8db8f0e88$exports = {};
$2e55afe8db8f0e88$exports = new URL("grass.85073952.webp", import.meta.url).toString();


var $ab0b179ad6ff9b1b$exports = {};
$ab0b179ad6ff9b1b$exports = new URL("wood-floor.ef0b798a.webp", import.meta.url).toString();


var $c5176f965e9af3f6$exports = {};
$c5176f965e9af3f6$exports = new URL("forest-grass.2edc1389.webp", import.meta.url).toString();


var $b90ff2e469e1a9eb$exports = {};
$b90ff2e469e1a9eb$exports = new URL("swamp-floor.b656f901.webp", import.meta.url).toString();


var $91a3ace66c39892d$exports = {};
$91a3ace66c39892d$exports = new URL("stone-brick.1f3f8e2a.webp", import.meta.url).toString();


var $e644993e32235161$exports = {};
$e644993e32235161$exports = new URL("rat.0710dbcc.webp", import.meta.url).toString();


var $d750d0a79e908481$exports = {};
$d750d0a79e908481$exports = new URL("rat-boss.266167ed.webp", import.meta.url).toString();


var $3cb5f38e6b83c351$exports = {};
$3cb5f38e6b83c351$exports = new URL("goblin.16b663ca.webp", import.meta.url).toString();


var $32a3e08deff98eb6$exports = {};
$32a3e08deff98eb6$exports = new URL("goblet.2a7d512c.webp", import.meta.url).toString();


var $71a00245fc2fd356$exports = {};
$71a00245fc2fd356$exports = new URL("ogre.befc24a7.webp", import.meta.url).toString();


var $f744abcfeee908fd$exports = {};
$f744abcfeee908fd$exports = new URL("goblin-king.3397b392.webp", import.meta.url).toString();


var $a888fd8264d71d43$exports = {};
$a888fd8264d71d43$exports = new URL("thaddeus.7b3e576a.webp", import.meta.url).toString();


var $51ba5aee65573b5b$exports = {};
$51ba5aee65573b5b$exports = new URL("door.dacf04e1.webp", import.meta.url).toString();


var $adac301e0faf2506$exports = {};
$adac301e0faf2506$exports = new URL("cellar-door.b0bd5091.webp", import.meta.url).toString();


var $ea9f4e4a250ba178$exports = {};
$ea9f4e4a250ba178$exports = new URL("castle-gate.514ee9a1.webp", import.meta.url).toString();


var $bf1d893b9e192962$exports = {};
$bf1d893b9e192962$exports = new URL("cathedral.1aba4e48.webp", import.meta.url).toString();


var $ed61281bfb2fdf96$exports = {};
$ed61281bfb2fdf96$exports = new URL("tower.d2df14e8.webp", import.meta.url).toString();


var $fef2123cede92b72$exports = {};
$fef2123cede92b72$exports = new URL("shop.be7d439a.webp", import.meta.url).toString();


var $0916a460a35a6fa3$exports = {};
$0916a460a35a6fa3$exports = new URL("castle.cddd126d.webp", import.meta.url).toString();


var $2c3b48131a895a1f$exports = {};
$2c3b48131a895a1f$exports = new URL("goblin-camp.6efcfb77.webp", import.meta.url).toString();


var $f1864910a3306556$exports = {};
$f1864910a3306556$exports = new URL("witch-hut.83d807f8.webp", import.meta.url).toString();


var $efa9e1cc5d70ab63$exports = {};
$efa9e1cc5d70ab63$exports = new URL("mirewood-tavern.4e13ed7a.webp", import.meta.url).toString();


var $564d0e95c962c160$exports = {};
$564d0e95c962c160$exports = new URL("mirewood-house.80b3f809.webp", import.meta.url).toString();


var $078de420033dcdc7$exports = {};
$078de420033dcdc7$exports = new URL("guard.65a69fa4.webp", import.meta.url).toString();


var $3a0f51a8937bafbe$exports = {};
$3a0f51a8937bafbe$exports = new URL("wizard-eldwin.9895eb70.webp", import.meta.url).toString();


var $cdb4cb7d8187eedc$exports = {};
$cdb4cb7d8187eedc$exports = new URL("shopkeeper-cedric.dcf764b0.webp", import.meta.url).toString();


var $96043c20c5211b09$exports = {};
$96043c20c5211b09$exports = new URL("father-michael.44a10438.webp", import.meta.url).toString();


var $e192b1ae55e004b5$exports = {};
$e192b1ae55e004b5$exports = new URL("king.e40a5e2a.webp", import.meta.url).toString();


var $91605deeca90e103$exports = {};
$91605deeca90e103$exports = new URL("jester-jeffrey.596fd8bb.webp", import.meta.url).toString();





var $4ba7b4add453389d$exports = {};
$4ba7b4add453389d$exports = new URL("witch.73ebae6b.webp", import.meta.url).toString();


var $bfd2fbedd143d2e8$exports = {};
$bfd2fbedd143d2e8$exports = new URL("bookshelf.927aa83b.webp", import.meta.url).toString();


var $aad979fe0afd7c98$exports = {};
$aad979fe0afd7c98$exports = new URL("altar.cbaf6e12.webp", import.meta.url).toString();


var $38b0c501d441320f$exports = {};
$38b0c501d441320f$exports = new URL("cauldron.34955e75.webp", import.meta.url).toString();


var $729189e0d74c3cba$exports = {};
$729189e0d74c3cba$exports = new URL("counter.eda3307e.webp", import.meta.url).toString();


var $9286f1c6d5e09196$exports = {};
$9286f1c6d5e09196$exports = new URL("stained-glass-1.77a2dbe2.webp", import.meta.url).toString();


var $0c65fa87de577467$exports = {};
$0c65fa87de577467$exports = new URL("stained-glass-2.c411fa5a.webp", import.meta.url).toString();


var $729e05b8eb12cb9d$exports = {};
$729e05b8eb12cb9d$exports = new URL("stained-glass-3.e12caf5c.webp", import.meta.url).toString();


var $16b0e23e059ace1c$exports = {};
$16b0e23e059ace1c$exports = new URL("stained-glass-4.f6308819.webp", import.meta.url).toString();


var $0dfa785dab1ffb08$exports = {};
$0dfa785dab1ffb08$exports = new URL("throne.7f39d510.webp", import.meta.url).toString();


var $8b6e59032f712d81$exports = {};
$8b6e59032f712d81$exports = new URL("basilisk-statue.354071f9.webp", import.meta.url).toString();


var $da062ea41b1683b4$exports = {};
$da062ea41b1683b4$exports = new URL("dragon-statue.69c47771.webp", import.meta.url).toString();


var $030d4be25979a75a$exports = {};
$030d4be25979a75a$exports = new URL("tree.e431cf61.webp", import.meta.url).toString();


var $a1dd7cbb9f5a7326$exports = {};
$a1dd7cbb9f5a7326$exports = new URL("chest.a00a5c4b.webp", import.meta.url).toString();


var $b5d952fd770c5048$exports = {};
$b5d952fd770c5048$exports = new URL("giant-tree.b3c678f7.webp", import.meta.url).toString();


// Use URL for images so that parcel knows to include them in the build.
const $846df9480552348c$var$images = {
    path: {
        cobblestone: new URL($c5175b3dbfa61bab$exports),
        grass: new URL($2e55afe8db8f0e88$exports),
        woodFloor: new URL($ab0b179ad6ff9b1b$exports),
        forestGrass: new URL($c5176f965e9af3f6$exports),
        swampFloor: new URL($b90ff2e469e1a9eb$exports)
    },
    wall: {
        stoneBrick: new URL($91a3ace66c39892d$exports)
    },
    enemy: {
        rat: new URL($e644993e32235161$exports),
        ratBoss: new URL($d750d0a79e908481$exports),
        goblin: new URL($3cb5f38e6b83c351$exports),
        goblet: new URL($32a3e08deff98eb6$exports),
        ogre: new URL($71a00245fc2fd356$exports),
        goblinKing: new URL($f744abcfeee908fd$exports)
    },
    thaddeus: new URL($a888fd8264d71d43$exports),
    entrance: {
        door: new URL($51ba5aee65573b5b$exports),
        cellarDoor: new URL($adac301e0faf2506$exports),
        castleGate: new URL($ea9f4e4a250ba178$exports),
        cathedral: new URL($bf1d893b9e192962$exports),
        tower: new URL($ed61281bfb2fdf96$exports),
        shop: new URL($fef2123cede92b72$exports),
        castle: new URL($0916a460a35a6fa3$exports),
        goblinCamp: new URL($2c3b48131a895a1f$exports),
        witchHut: new URL($f1864910a3306556$exports),
        mirewoodTavern: new URL($efa9e1cc5d70ab63$exports),
        mirewoodHouse: new URL($564d0e95c962c160$exports)
    },
    npc: {
        guard: new URL($078de420033dcdc7$exports),
        wizardEldwin: new URL($3a0f51a8937bafbe$exports),
        shopkeeperCedric: new URL($cdb4cb7d8187eedc$exports),
        fatherMichael: new URL($96043c20c5211b09$exports),
        king: new URL($e192b1ae55e004b5$exports),
        jesterJeffrey: new URL($91605deeca90e103$exports),
        ratBoss: new URL($d750d0a79e908481$exports),
        goblinKing: new URL($f744abcfeee908fd$exports),
        goblin: new URL($3cb5f38e6b83c351$exports),
        witch: new URL($4ba7b4add453389d$exports)
    },
    object: {
        bookshelf: new URL($bfd2fbedd143d2e8$exports),
        altar: new URL($aad979fe0afd7c98$exports),
        cauldron: new URL($38b0c501d441320f$exports),
        counter: new URL($729189e0d74c3cba$exports),
        stainedGlass1: new URL($9286f1c6d5e09196$exports),
        stainedGlass2: new URL($0c65fa87de577467$exports),
        stainedGlass3: new URL($729e05b8eb12cb9d$exports),
        stainedGlass4: new URL($16b0e23e059ace1c$exports),
        throne: new URL($0dfa785dab1ffb08$exports),
        basiliskStatue: new URL($8b6e59032f712d81$exports),
        dragonStatue: new URL($da062ea41b1683b4$exports),
        tree: new URL($030d4be25979a75a$exports),
        chest: new URL($a1dd7cbb9f5a7326$exports),
        giantTree: new URL($b5d952fd770c5048$exports)
    }
};
const $846df9480552348c$var$customTileStyles = {
    object: {
        counter: {
            width: "150%",
            height: "150%",
            left: "-10px",
            bottom: "20px",
            "z-index": 2
        },
        bookshelf: {
            width: "120%",
            height: "120%",
            left: "-7px",
            bottom: "-4px"
        },
        cauldron: {
            width: "125%",
            height: "125%",
            left: "-7px",
            bottom: "25px",
            "z-index": 2
        },
        altar: {
            width: "200%",
            height: "200%",
            left: "-32px",
            bottom: "-25px"
        },
        throne: {
            width: "160%",
            height: "160%",
            left: "-20px",
            bottom: "45px"
        },
        dragonStatue: {
            width: "250%",
            height: "250%",
            left: "-42px",
            bottom: "-17px",
            "z-index": 2
        },
        basiliskStatue: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-5px",
            "z-index": 2
        },
        tree: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-5px",
            "z-index": 2
        },
        giantTree: {
            width: "500%",
            height: "500%",
            left: "-119px",
            bottom: "50px",
            "z-index": 2
        }
    },
    entrance: {
        cathedral: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "0px",
            "z-index": 2
        },
        tower: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-5px",
            "z-index": 2
        },
        shop: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-12px",
            "z-index": 2
        },
        castle: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-7px",
            "z-index": 2
        },
        goblinCamp: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-5px",
            "z-index": 2
        },
        witchHut: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-10px",
            "z-index": 3
        },
        mirewoodTavern: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-5px",
            "z-index": 2
        },
        mirewoodHouse: {
            width: "200%",
            height: "200%",
            left: "-30px",
            bottom: "-5px",
            "z-index": 2
        }
    }
};
// The max height if there is no dialogue is 9 tiles, otherwise it is 7 tiles.
// The max width is 9 tiles.
const $846df9480552348c$var$createLayout = (locationName)=>{
    const location = $846df9480552348c$var$locations.find((location)=>location.name === locationName);
    const wallObject = location.wallObject || {
        type: "wall"
    };
    const walls = location.walls || [];
    let layout = [];
    for(let y = 0; y < location.height; y++)for(let x = 0; x < location.width; x++){
        if (walls.includes("top") && y === location.height - 1) layout.push({
            ...wallObject,
            x: x,
            y: y
        });
        else if (walls.includes("bottom") && y === 0) layout.push({
            ...wallObject,
            x: x,
            y: y
        });
        else if (walls.includes("left") && x === 0) layout.push({
            ...wallObject,
            x: x,
            y: y
        });
        else if (walls.includes("right") && x === location.width - 1) layout.push({
            ...wallObject,
            x: x,
            y: y
        });
        else layout.push({
            type: "path",
            x: x,
            y: y
        });
    }
    layout = layout.map((pathTile)=>{
        const tile = location.tiles.find((tile)=>tile.x === pathTile.x && tile.y === pathTile.y);
        if (tile) return tile;
        return pathTile;
    });
    return layout;
};
const $846df9480552348c$var$getLocationTiles = (locationName)=>{
    const locationTiles = $846df9480552348c$var$createLayout(locationName);
    // Combine the location's tiles with the player's modified tiles.
    if (!(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName]) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName] = [];
    const modifiedTiles = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName];
    const tiles = locationTiles.map((tile)=>({
            ...tile,
            ...modifiedTiles.find((modifiedTile)=>modifiedTile.x === tile.x && modifiedTile.y === tile.y) || {}
        }));
    // Combine the location's NPCs with the player's modified NPCs.
    const npcArray = (0, $bc4efe90a4dcd3ee$export$51aacac15ce329c4).npcList.map((npc)=>({
            ...npc,
            ...(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedNpcs.find((modifiedNpc)=>modifiedNpc.name === npc.name) || {}
        })).filter((npc)=>npc.location === locationName);
    // Add the NPCs to the tiles.
    return tiles.map((tile)=>({
            ...tile,
            ...npcArray.find((npc)=>npc.x === tile.x && npc.y === tile.y) || {}
        }));
};
const $846df9480552348c$var$addModifiedTile = (locationName, tile)=>{
    // If the tile is already in the modified tiles array, then add the new values to that object.
    const modifiedTile = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName].find((modifiedTile)=>modifiedTile.x === tile.x && modifiedTile.y === tile.y);
    if (modifiedTile) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName] = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName].map((modifiedTile)=>modifiedTile.x === tile.x && modifiedTile.y === tile.y ? {
            ...modifiedTile,
            ...tile
        } : modifiedTile);
    else (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedTiles[locationName].push(tile);
};
const $846df9480552348c$var$addModifiedNpc = (npc)=>{
    // If the NPC is already in the modified NPCs array, then add the new values to that object.
    const modifiedNpc = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedNpcs.find((modifiedNpc)=>modifiedNpc.name === npc.name);
    if (modifiedNpc) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedNpcs = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedNpcs.map((modifiedNpc)=>modifiedNpc.name === npc.name ? {
            ...modifiedNpc,
            ...npc
        } : modifiedNpc);
    else (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).modifiedNpcs.push(npc);
};
const $846df9480552348c$var$displayLocation = async (locationName, entranceName)=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation = locationName;
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    if (entranceName) {
        const entrance = tiles.find((tile)=>tile.type === "entrance" && tile.location === entranceName);
        (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x = entrance.x;
        (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y = entrance.y;
        // Every entrance has a direction that it outputs the player to.
        const entranceDirection = entrance.outputDirection;
        if (entranceDirection === "up") (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y += 1;
        if (entranceDirection === "down") (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y -= 1;
        if (entranceDirection === "left") (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x -= 1;
        if (entranceDirection === "right") (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x += 1;
    }
    const mainDisplay = document.getElementById("mainDisplay");
    mainDisplay.innerHTML = "";
    const displayDiv = document.createElement("div");
    displayDiv.classList.add("display-div");
    // Check if an enemy should display instead of the map.
    if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy) {
        // Add a gap between the enemy's health bar and the image of the enemy.
        displayDiv.style.gap = "10px";
        // Display the enemy's health bar
        const healthContainer = document.createElement("div");
        healthContainer.classList.add("health-container");
        healthContainer.id = "enemyHealthContainer";
        healthContainer.style.display = "flex";
        const healthLabel = document.createElement("span");
        healthLabel.id = "enemyHealthLabel";
        healthLabel.classList.add("health-label");
        healthLabel.style.textTransform = "capitalize";
        healthLabel.textContent = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy.name;
        const healthBar = document.createElement("div");
        healthBar.classList.add("health-bar");
        healthBar.id = "healthBar";
        const healthLevel = document.createElement("div");
        healthLevel.classList.add("health-level");
        healthLevel.id = "enemyHealthLevel";
        const enemyHpDisplay = document.createElement("div");
        enemyHpDisplay.id = "enemyHpDisplay";
        enemyHpDisplay.classList.add("hp-display");
        healthLevel.appendChild(enemyHpDisplay);
        healthBar.appendChild(healthLevel);
        healthContainer.appendChild(healthLabel);
        healthContainer.appendChild(healthBar);
        displayDiv.appendChild(healthContainer);
        const imgElement = document.createElement("img");
        imgElement.draggable = false;
        imgElement.src = $846df9480552348c$var$images.enemy[(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy.tileImage];
        imgElement.style.width = "200px";
        displayDiv.appendChild(imgElement);
        mainDisplay.appendChild(displayDiv);
        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
            dialogueName: (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy.encounterDialogueFunction()
        });
        return (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateHealthBar("enemyHealthLevel", (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy.hp, (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy.maxHp);
    }
    // Determine the number of rows and columns
    const rows = Math.max(...tiles.map((tile)=>tile.y)) + 1;
    const columns = Math.max(...tiles.map((tile)=>tile.x)) + 1;
    // Create a 2D array to hold the tiles
    const grid = Array.from({
        length: rows
    }, ()=>Array(columns).fill(null));
    // Place each tile in the correct position in the grid
    tiles.forEach((tile)=>{
        grid[tile.y][tile.x] = tile;
    });
    grid.reverse();
    // Iterate through the grid and create row and tile elements
    grid.forEach((row)=>{
        const rowElement = document.createElement("div");
        rowElement.style.display = "flex";
        row.forEach((tile)=>{
            const tileElement = document.createElement("div");
            tileElement.style.width = "55px";
            tileElement.style.height = "55px";
            tileElement.id = `${tile.x}-${tile.y}`;
            if (tile.type !== "empty") {
                // Display a background image for the tile.
                const background = [
                    "wall",
                    "path"
                ].includes(tile.type) ? tile.type : tile.tileBackground || "path";
                let image = "";
                if (background === "path") {
                    const pathImage = $846df9480552348c$var$locations.find((location)=>location.name === locationName).pathImage;
                    image = $846df9480552348c$var$images.path[pathImage];
                } else if (background === "wall") {
                    const wallImage = $846df9480552348c$var$locations.find((location)=>location.name === locationName).wallImage;
                    image = $846df9480552348c$var$images.wall[wallImage];
                }
                // This background image is displayed behind the tile image.
                tileElement.style.backgroundImage = `url(${image})`;
                tileElement.style.backgroundSize = "cover";
                if (tile.type === "entrance") tileElement.classList.add("entrance-tile");
                // Create an img element inside the div to display the tile image.
                const isPlayer = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x === tile.x && (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y === tile.y;
                if (![
                    "wall",
                    "path"
                ].includes(tile.type) && tile.tileImage || isPlayer) {
                    const imgElement = $846df9480552348c$var$getTileImage(tile, isPlayer);
                    tileElement.appendChild(imgElement);
                }
            }
            rowElement.appendChild(tileElement);
        });
        displayDiv.appendChild(rowElement);
    });
    mainDisplay.appendChild(displayDiv);
    $846df9480552348c$var$checkNearbyInteraction();
    // Pre-load images for attached locations.
    $846df9480552348c$var$preloadImages();
};
const $846df9480552348c$var$preloadImages = ()=>{
    // Pre-load all images for all attached locations.
    const locationName = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation;
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    // Attached locations are locations that there is an entrance to from the current location.
    const attachedLocations = tiles.filter((tile)=>tile.type === "entrance").map((entrance)=>entrance.location).filter(Boolean);
    let imagesToPreload = [];
    for (const locationName of attachedLocations){
        const location = $846df9480552348c$var$locations.find((location)=>location.name === locationName);
        const locationTiles = $846df9480552348c$var$getLocationTiles(locationName);
        const locationImages = locationTiles.map((tile)=>{
            return tile.tileImage && $846df9480552348c$var$images[tile.type]?.[tile.tileImage];
        });
        // Add path and wall images.
        locationImages.push($846df9480552348c$var$images.path[location.pathImage], $846df9480552348c$var$images.wall[location.wallImage]);
        imagesToPreload.push(...locationImages);
    }
    // Filter out undefined and duplicate images.
    imagesToPreload = imagesToPreload.filter((image, index)=>image && imagesToPreload.indexOf(image) === index);
    for (const image of imagesToPreload){
        const img = new Image();
        img.src = image;
    }
};
const $846df9480552348c$var$getTileImage = (tile, isPlayer)=>{
    let type = tile.type;
    let image;
    if (![
        "wall",
        "path"
    ].includes(type)) image = $846df9480552348c$var$images[type]?.[tile.tileImage];
    let imgElement;
    if (image) {
        imgElement = document.createElement("img");
        imgElement.src = image;
        imgElement.style.position = "absolute";
        imgElement.style.width = "100%";
        imgElement.style.height = "100%";
        imgElement.draggable = false;
        if (type === "npc") imgElement.style.zIndex = 1;
        if ($846df9480552348c$var$customTileStyles?.[type]?.[tile.tileImage]) {
            const customStyle = $846df9480552348c$var$customTileStyles[type][tile.tileImage];
            for (const [key, value] of Object.entries(customStyle))imgElement.style[key] = value;
        }
    }
    let playerImageElement;
    if (isPlayer) {
        playerImageElement = document.createElement("img");
        playerImageElement.src = $846df9480552348c$var$images.thaddeus;
        playerImageElement.style.position = "absolute";
        playerImageElement.style.zIndex = 1;
        if (tile["z-index"]) playerImageElement.style.zIndex = tile["z-index"];
        playerImageElement.style.width = "100%";
        playerImageElement.style.height = "100%";
        playerImageElement.draggable = false;
    }
    const imgDiv = document.createElement("div");
    imgDiv.style.width = "100%";
    imgDiv.style.height = "100%";
    imgDiv.style.position = "relative";
    if (imgElement) imgDiv.appendChild(imgElement);
    if (playerImageElement) imgDiv.appendChild(playerImageElement);
    return imgDiv;
};
// Sees where the player can move based on their current location and the non-empty tiles in the dungeon layout.
const $846df9480552348c$var$availableDirections = (locationName)=>{
    if (!(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).canExitDialogue) return [];
    if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy) return [];
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    const noMovementTypes = [
        "wall",
        "npc"
    ];
    const up = tiles.find((tile)=>tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y + 1 && !noMovementTypes.includes(tile.type) && !tile.noMovement);
    const down = tiles.find((tile)=>tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y - 1 && !noMovementTypes.includes(tile.type) && !tile.noMovement);
    const left = tiles.find((tile)=>tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x - 1 && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y && !noMovementTypes.includes(tile.type) && !tile.noMovement);
    const right = tiles.find((tile)=>tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x + 1 && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y && !noMovementTypes.includes(tile.type) && !tile.noMovement);
    const actions = [];
    if (up) actions.push("up");
    if (down) actions.push("down");
    if (left) actions.push("left");
    if (right) actions.push("right");
    return actions;
};
const $846df9480552348c$var$findPath = (startX, startY, targetX, targetY, tiles)=>{
    const noMovementTypes = [
        "wall",
        "npc",
        "empty"
    ];
    const openList = [];
    const closedList = [];
    const path = [];
    const targetReachable = tiles.find((tile)=>tile.x === targetX && tile.y === targetY && !noMovementTypes.includes(tile.type) && !tile.noMovement);
    // If the target tile is not reachable, then find the closest tile to the player that is reachable.
    // Should be the closest to the target and if the distance to target is the same, then closest to the player.
    if (!targetReachable) {
        let closestTile = {
            x: startX,
            y: startY,
            distance: Infinity
        };
        for (const tile of tiles){
            // Don't move the player to an entrance if they did not select that entrance as their target.
            if (noMovementTypes.includes(tile.type) || tile.noMovement || tile.type === "entrance") continue;
            const distance = Math.abs(tile.x - targetX) + Math.abs(tile.y - targetY);
            if (distance < closestTile.distance) closestTile = {
                x: tile.x,
                y: tile.y,
                distance: distance
            };
            else if (distance === closestTile.distance) {
                const playerDistance = Math.abs(tile.x - startX) + Math.abs(tile.y - startY);
                const closestPlayerDistance = Math.abs(closestTile.x - startX) + Math.abs(closestTile.y - startY);
                if (playerDistance < closestPlayerDistance) closestTile = {
                    x: tile.x,
                    y: tile.y,
                    distance: distance
                };
            }
        }
        targetX = closestTile.x;
        targetY = closestTile.y;
    }
    // This is the A* path finding algorithm.
    // f-score is the sum of g-score and h-score.
    // g-score is the distance to the current point, h-score is the estimated remaining distance.
    const startNode = {
        x: startX,
        y: startY,
        g: 0,
        h: 0,
        f: 0,
        parent: null
    };
    openList.push(startNode);
    while(openList.length){
        openList.sort((a, b)=>a.f - b.f);
        // Process the nodes by lowest f-score first so that we can find the quickest path to the target.
        const currentNode = openList.shift();
        closedList.push(currentNode);
        // If this is the target, then we found the quickest path.
        if (currentNode.x === targetX && currentNode.y === targetY) {
            let current = currentNode;
            while(current.parent){
                path.push({
                    x: current.x,
                    y: current.y
                });
                current = current.parent;
            }
            return path.reverse();
        }
        const adjacentTiles = [
            {
                x: currentNode.x,
                y: currentNode.y + 1
            },
            {
                x: currentNode.x,
                y: currentNode.y - 1
            },
            {
                x: currentNode.x - 1,
                y: currentNode.y
            },
            {
                x: currentNode.x + 1,
                y: currentNode.y
            }
        ];
        for (const adjacent of adjacentTiles){
            const adjacentTile = tiles.find((tile)=>tile.x === adjacent.x && tile.y === adjacent.y);
            // Don't add tiles to the open list that are inaccessible, already been searched, or need to be avoided.
            if (!adjacentTile || noMovementTypes.includes(adjacentTile.type) || adjacentTile.noMovement) continue;
            if (closedList.find((node)=>node.x === adjacent.x && node.y === adjacent.y)) continue;
            if (adjacentTile.type === "entrance" && (adjacent.x !== targetX || adjacent.y !== targetY)) continue;
            const g = currentNode.g + 1;
            const h = Math.abs(adjacent.x - targetX) + Math.abs(adjacent.y - targetY);
            const f = g + h;
            const openNode = openList.find((node)=>node.x === adjacent.x && node.y === adjacent.y);
            if (openNode) // If the g-score is improved using this path, then update the node in the open list.
            {
                if (g < openNode.g) {
                    openNode.g = g;
                    openNode.f = f;
                    openNode.parent = currentNode;
                }
            } else openList.push({
                x: adjacent.x,
                y: adjacent.y,
                g: g,
                h: h,
                f: f,
                parent: currentNode
            });
        }
    }
    return path;
};
const $846df9480552348c$var$movePlayerTap = async (locationName, tileX, tileY, overrideMoveablity)=>{
    $846df9480552348c$var$isMoving = true;
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    // Find a path to the target tile. The player cannot move to wall, npc, empty, or noMovement tiles.
    const path = $846df9480552348c$var$findPath((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x, (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y, tileX, tileY, tiles);
    if (!path.length) return $846df9480552348c$var$isMoving = false;
    (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons();
    for(let i = 0; i < path.length; i++){
        const nextTile = path[i];
        const direction = nextTile.x < (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x ? "left" : nextTile.x > (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x ? "right" : nextTile.y < (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y ? "down" : "up";
        // If they cannot move to the tile, then abort the movement.
        if (!overrideMoveablity && !$846df9480552348c$var$availableDirections(locationName).includes(direction)) return $846df9480552348c$var$isMoving = false;
        const eventOccured = $846df9480552348c$var$movePlayer(locationName, direction, true);
        if (eventOccured) break;
        if (i !== path.length - 1) await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(200);
    }
    if (!overrideMoveablity) {
        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
        $846df9480552348c$var$checkNearbyInteraction();
    }
    $846df9480552348c$var$isMoving = false;
};
const $846df9480552348c$var$movePlayer = (locationName, direction, npcPush)=>{
    if (!npcPush && !$846df9480552348c$var$availableDirections(locationName).includes(direction)) return;
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    let newPlayer = {
        x: (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x,
        y: (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y
    };
    switch(direction){
        case "up":
            newPlayer.y += 1;
            break;
        case "down":
            newPlayer.y -= 1;
            break;
        case "left":
            newPlayer.x -= 1;
            break;
        case "right":
            newPlayer.x += 1;
            break;
    }
    // Find the tile the player is moving to
    const targetTile = tiles.find((tile)=>tile.x === newPlayer.x && tile.y === newPlayer.y);
    if (targetTile.type === "entrance" && !targetTile.locked) {
        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
        return $846df9480552348c$var$displayLocation(targetTile.location, locationName);
    } else if (targetTile.type === "entrance" && targetTile.locked) return (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
        dialogueName: targetTile.lockedDialogue
    });
    // Move the player to the new tile
    const targetTileElement = document.getElementById(`${newPlayer.x}-${newPlayer.y}`);
    targetTileElement.innerHTML = "";
    const targetImgElement = $846df9480552348c$var$getTileImage(targetTile, true);
    targetTileElement.appendChild(targetImgElement);
    // Reset the previous tile
    const previousTileElement = document.getElementById(`${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x}-${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y}`);
    previousTileElement.innerHTML = "";
    const previousTile = tiles.find((tile)=>tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y);
    if (![
        "wall",
        "path"
    ].includes(previousTile.type)) {
        const previousImgElement = $846df9480552348c$var$getTileImage(previousTile);
        previousTileElement.appendChild(previousImgElement);
    }
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x = newPlayer.x;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y = newPlayer.y;
    if ((0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).checkForCombat()) return $846df9480552348c$export$17b07c660794dc13.displayLocation((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
    else if (!npcPush) {
        (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
        $846df9480552348c$var$checkNearbyInteraction();
    }
};
// Check if the player is next to an NPC, if so give the option to talk to them.
const $846df9480552348c$var$checkNearbyInteraction = ()=>{
    const tiles = $846df9480552348c$var$getLocationTiles((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
    const nearbyNpc = tiles.filter((tile)=>tile.type === "npc" && ((tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x + 1 || tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x - 1) && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y || (tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y + 1 || tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y - 1) && tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x));
    const nearbyInteractables = tiles.filter((tile)=>tile.displayFunction && tile.dialogueFunction && ((tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x + 1 || tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x - 1) && tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y || (tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y + 1 || tile.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y - 1) && tile.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x));
    const options = [];
    if (nearbyNpc.length) for (const npc of nearbyNpc){
        const dialogueName = npc.dialogueFunction?.();
        options.push({
            display: `Talk to ${npc.name}`,
            function: ()=>(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
                    dialogueName: dialogueName
                })
        });
    }
    if (nearbyInteractables.length) for (const interactable of nearbyInteractables){
        const dialogueName = interactable.dialogueFunction?.();
        options.push({
            display: interactable.displayFunction(),
            function: ()=>(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
                    dialogueName: dialogueName
                })
        });
    }
    (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons(options);
};
const $846df9480552348c$var$moveNpc = (locationName, npcName, direction)=>{
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    const npc = tiles.find((tile)=>tile.type === "npc" && tile.name === npcName);
    let newNpc = {
        x: npc.x,
        y: npc.y
    };
    switch(direction){
        case "up":
            newNpc.y += 1;
            break;
        case "down":
            newNpc.y -= 1;
            break;
        case "left":
            newNpc.x -= 1;
            break;
        case "right":
            newNpc.x += 1;
            break;
    }
    // Move the npc to the new tile
    const targetTileElement = document.getElementById(`${newNpc.x}-${newNpc.y}`);
    targetTileElement.innerHTML = "";
    const targetImgElement = $846df9480552348c$var$getTileImage(npc);
    targetTileElement.appendChild(targetImgElement);
    const movingToPlayerTile = newNpc.x === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).x && newNpc.y === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).y;
    // Set the previous tile to the tile type that the NPC is moving to
    const newTile = tiles.find((tile)=>tile.x === newNpc.x && tile.y === newNpc.y);
    if (!movingToPlayerTile) {
        const previousTileElement = document.getElementById(`${npc.x}-${npc.y}`);
        previousTileElement.innerHTML = "";
        if (![
            "wall",
            "path"
        ].includes(newTile.type)) {
            const previousImgElement = $846df9480552348c$var$getTileImage(newTile);
            previousTileElement.appendChild(previousImgElement);
        }
    }
    // Update the tiles array with the new location of the NPC
    $846df9480552348c$var$addModifiedNpc({
        name: npcName,
        x: newNpc.x,
        y: newNpc.y
    });
    // If the NPC is moving to the player's location, then move the player to the NPC's location
    if (movingToPlayerTile) {
        const inverseDirection = {
            up: "down",
            down: "up",
            left: "right",
            right: "left"
        };
        $846df9480552348c$var$movePlayer(locationName, inverseDirection[direction], true);
    }
};
const $846df9480552348c$var$moveNpcLocation = (npcName, locationName, newLocationName, newX, newY)=>{
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    const npc = tiles.find((tile)=>tile.type === "npc" && tile.name === npcName);
    // Move the npc to the new location
    $846df9480552348c$var$addModifiedNpc({
        name: npcName,
        x: newX,
        y: newY,
        location: newLocationName
    });
    // Replace the old NPC tile with a path tile.
    if (locationName == (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation) {
        const oldNpcTileElement = document.getElementById(`${npc.x}-${npc.y}`);
        oldNpcTileElement.innerHTML = "";
        const newTiles = $846df9480552348c$var$getLocationTiles(locationName);
        const oldNpcTile = newTiles.find((tile)=>tile.x === npc.x && tile.y === npc.y);
        if (![
            "wall",
            "path"
        ].includes(oldNpcTile.type)) {
            const oldNpcImgElement = $846df9480552348c$var$getTileImage(oldNpcTile);
            oldNpcTileElement.appendChild(oldNpcImgElement);
        }
    }
};
const $846df9480552348c$var$unlockEntrance = (locationName, entranceName)=>{
    const tiles = $846df9480552348c$var$getLocationTiles(locationName);
    const entrance = tiles.find((tile)=>tile.type === "entrance" && tile.location === entranceName);
    $846df9480552348c$var$addModifiedTile(locationName, {
        x: entrance.x,
        y: entrance.y,
        locked: false
    });
};
const $846df9480552348c$var$setupMovementListener = ()=>{
    document.addEventListener("keydown", async (event)=>{
        if ($846df9480552348c$var$locations.find((location)=>location.name === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation) && !$846df9480552348c$var$isMoving) {
            $846df9480552348c$var$isMoving = true;
            let direction;
            switch(event.key){
                case "ArrowUp":
                case "w":
                case "W":
                    direction = "up";
                    break;
                case "ArrowDown":
                case "s":
                case "S":
                    direction = "down";
                    break;
                case "ArrowLeft":
                case "a":
                case "A":
                    direction = "left";
                    break;
                case "ArrowRight":
                case "d":
                case "D":
                    direction = "right";
                    break;
            }
            if (direction) $846df9480552348c$var$movePlayer((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation, direction);
            // Small delay before allowing the player to move again to prevent rapid movement.
            await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(200);
            $846df9480552348c$var$isMoving = false;
        }
    });
    // Click/tap to move functionality.
    const mainDisplay = document.getElementById("mainDisplay");
    mainDisplay.addEventListener("click", async (event)=>{
        // Prevent attempted movement while the player is talking or fighting.
        if (!(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).canExitDialogue || (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy) return;
        if (!$846df9480552348c$var$isMoving && $846df9480552348c$var$locations.find((location)=>location.name === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation)) {
            // Can't use simple event.target because some objects span multiple tiles.
            // Get the coordinates of where the click happened.
            const mainDisplayStyle = window.getComputedStyle(mainDisplay);
            const bodyStyle = window.getComputedStyle(document.body);
            const zoom = (bodyStyle.zoom || 1) * (mainDisplayStyle.zoom || 1);
            const clientX = event.clientX;
            const clientY = event.clientY;
            const mainDisplayX = mainDisplay.offsetLeft * zoom;
            const mainDisplayY = mainDisplay.offsetTop * zoom;
            const clickX = clientX - mainDisplayX;
            const clickY = clientY - mainDisplayY;
            // Get the dimensions of the location.
            const location = $846df9480552348c$var$locations.find((location)=>location.name === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
            const mainDisplayWidth = parseInt(mainDisplayStyle.width) * zoom;
            const mainDisplayHeight = parseInt(mainDisplayStyle.height) * zoom;
            const tileWidth = mainDisplayWidth / location.width;
            const tileHeight = mainDisplayHeight / location.height;
            // Find the tile that was clicked.
            const x = Math.floor(clickX / tileWidth);
            // Need to invert the y value because the grid is drawn from the top left corner.
            const y = location.height - Math.floor(clickY / tileHeight) - 1;
            await $846df9480552348c$var$movePlayerTap((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation, x, y);
        }
    });
};
const $846df9480552348c$var$hideDisplay = ()=>{
    const mainDisplay = document.getElementById("mainDisplay");
    mainDisplay.innerHTML = "";
};
const $846df9480552348c$var$showDisplay = ()=>{
    const mainDisplay = document.getElementById("mainDisplay");
    mainDisplay.style.display = "flex";
};
const $846df9480552348c$export$17b07c660794dc13 = {
    locations: $846df9480552348c$var$locations,
    getLocationTiles: $846df9480552348c$var$getLocationTiles,
    addModifiedTile: $846df9480552348c$var$addModifiedTile,
    displayLocation: $846df9480552348c$var$displayLocation,
    moveNpc: $846df9480552348c$var$moveNpc,
    moveNpcLocation: $846df9480552348c$var$moveNpcLocation,
    movePlayerTap: $846df9480552348c$var$movePlayerTap,
    setupMovementListener: $846df9480552348c$var$setupMovementListener,
    checkNearbyInteraction: $846df9480552348c$var$checkNearbyInteraction,
    unlockEntrance: $846df9480552348c$var$unlockEntrance,
    hideDisplay: $846df9480552348c$var$hideDisplay,
    showDisplay: $846df9480552348c$var$showDisplay,
    images: $846df9480552348c$var$images
};







const $a02de5696100d47d$var$fastTravelLocations = [
    {
        name: "elarianCourtyard",
        display: "Elarian Courtyard"
    },
    {
        name: "mirewoodCourtyard",
        display: "Mirewood Courtyard"
    }
];
const $a02de5696100d47d$var$requireFastTravelObject = {
    or: []
};
// Generate all possible combinations of two locations
for(let i = 0; i < $a02de5696100d47d$var$fastTravelLocations.length; i++)for(let j = i + 1; j < $a02de5696100d47d$var$fastTravelLocations.length; j++)$a02de5696100d47d$var$requireFastTravelObject.or.push({
    and: [
        {
            check: `${$a02de5696100d47d$var$fastTravelLocations[i].name}.statueActions`
        },
        {
            check: `${$a02de5696100d47d$var$fastTravelLocations[j].name}.statueActions`
        }
    ]
});
const $a02de5696100d47d$export$d4e22b55fa08e445 = (locationName)=>{
    return {
        statueActions: {
            textFunction: ()=>{
                const includesAnotherStatue = $a02de5696100d47d$var$fastTravelLocations.some((location)=>(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue(`${location.name}.statueActions`));
                let additionalMessage = "";
                if (includesAnotherStatue && !(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue(`${locationName}.statueActions`)) additionalMessage = `You are now able to fast travel to this location from any statue! `;
                else if (!includesAnotherStatue) additionalMessage = `You can use statues to save your game and fast travel if you have used more than one statue! `;
                return `You put your sword in the slit. ${additionalMessage}What would you like to do?`;
            },
            includeClose: true,
            options: [
                {
                    display: "Save your game",
                    next: `${locationName}.statueActions.saveGame`
                },
                {
                    requires: $a02de5696100d47d$var$requireFastTravelObject,
                    display: "Fast travel",
                    next: `${locationName}.statueActions.fastTravel`
                }
            ],
            saveGame: {
                text: `Your game has been saved!`,
                // Save the game before the dialogue is shown, since that leaves less room for the player to close the game before the save is complete.
                prefunction: ()=>{
                    (0, $504c2f61098a857b$export$7debb50ef11d5e0b).saveGame();
                }
            },
            fastTravel: {
                text: `Where would you like to fast travel?`,
                includeClose: true,
                options: $a02de5696100d47d$var$fastTravelLocations.map((location)=>({
                        requires: {
                            check: `${location.name}.statueActions`
                        },
                        display: location.display,
                        next: `${locationName}.statueActions.fastTravel.${location.name}`
                    })).filter((option)=>option.next !== `${locationName}.statueActions.fastTravel.${locationName}`),
                ...$a02de5696100d47d$var$fastTravelLocations.reduce((acc, location)=>{
                    acc[location.name] = {
                        text: `The statue around your sword transforms. You are now in the ${location.display}!`,
                        prefunction: async ()=>{
                            // This works as long as the statues are all located at 3, 3.
                            // If the statues are located at different coordinates, then then this will need to be updated.
                            await (0, $846df9480552348c$export$17b07c660794dc13).displayLocation(location.name);
                        }
                    };
                    return acc;
                }, {})
            }
        }
    };
};






const $f8ab3c8e2d8259e4$var$returnOption = [
    {
        display: "Return to map",
        function: ()=>(0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).returnToMap()
    }
];
const $f8ab3c8e2d8259e4$export$180f09cbecaa3c42 = {
    shopCellar: {
        combat: {
            text: "What will you do?",
            manualOptions: true,
            function: ()=>{
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons((0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).getAttackOptions());
            }
        },
        firstRat: {
            text: "A rat appears! I think it might be smiling? Not exactly vicious... I am not sure why Cedric is so scared of these things.",
            next: "shopCellar.combat",
            function: ()=>{
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).revealHealthAndXp();
            }
        },
        rat: {
            textFunction: ()=>{
                const textOptions = [
                    "A rat appears! And it looks very cute! Well, it is still in your way.",
                    "A rat jumps out from behind a barrel! It looks like it is ready to fight.",
                    "A rat is blocking your path! Well, I guess you could walk over it, but it might bite you."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            next: "shopCellar.combat"
        },
        firstDefeatRat: {
            text: "You defeated the rat. I hope he didn't have a family...",
            options: $f8ab3c8e2d8259e4$var$returnOption
        },
        defeatRat: {
            textFunction: ()=>{
                const textOptions = [
                    "The rat falls to the ground. Poor guy... At least he dropped some gold.",
                    "You defeated the rat. It had some gold in its mouth.",
                    "You defeated the rat. Hopefully it learned its lesson."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            options: $f8ab3c8e2d8259e4$var$returnOption
        },
        treasure1: {
            text: "You found 25 gold.",
            function: ()=>{
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateGold(25);
                (0, $846df9480552348c$export$17b07c660794dc13).addModifiedTile("shopCellarEntrance", {
                    type: "path",
                    x: 0,
                    y: 5,
                    tileImage: null,
                    dialogueFunction: null,
                    displayFunction: null,
                    noMovement: null
                });
                (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("shopCellarEntrance");
            }
        },
        treasure2: {
            text: "You found 25 gold.",
            function: ()=>{
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateGold(25);
                (0, $846df9480552348c$export$17b07c660794dc13).addModifiedTile("shopCellarEntrance", {
                    type: "path",
                    x: 6,
                    y: 5,
                    tileImage: null,
                    dialogueFunction: null,
                    displayFunction: null,
                    noMovement: null
                });
                (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("shopCellarEntrance");
            }
        },
        wine: {
            text: "You found a crate of vintage wine. Cedric will be pleased.",
            function: ()=>{
                (0, $846df9480552348c$export$17b07c660794dc13).addModifiedTile("shopCellarWineRoom", {
                    type: "path",
                    x: 1,
                    y: 2,
                    tileImage: null,
                    dialogueFunction: null,
                    displayFunction: null,
                    noMovement: null
                });
                (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("shopCellarWineRoom");
            }
        }
    }
};


const $6fc86d4595310317$export$5f261e47b4e31f76 = {
    ...(0, $f8ab3c8e2d8259e4$export$180f09cbecaa3c42),
    elarianGates: {
        intro: {
            text: `The Great Dragon ruled over the kingdom of Glenfall since it was founded five hundred years ago.
That was until the year 422 AD (Anno Draconis - In the Year of the Dragon) when the Great Dragon was killed by the Dark One,
which ushered in a Dark Age of the kingdom.`,
            options: [
                {
                    display: "Continue",
                    next: "elarianGates.intro2"
                },
                {
                    display: "Skip Intro",
                    next: "elarianGates.intro4"
                }
            ],
            next: "elarianGates.intro2"
        },
        intro2: {
            text: `It is now the year 460 AD.
The Great King, who sees himself as the true successor of the dragon, maintains limited dominion over Glenfall's capital city - Elarian.
The Dark One's dominion extends throughout the rest of the kingdom.`,
            next: "elarianGates.intro3"
        },
        intro3: {
            text: `You are Thaddeus, a peasant who has managed to make his way to the capital.
Your aspiration is to defeat the Dark One and finally free the kingdom from his tyranny.
You hope to speak with the Great King and get his blessing to embark on this quest.
After a long journey, you finally arrive at the city gates.`,
            next: "elarianGates.intro4"
        },
        intro4: {
            text: `Use the arrow keys, wasd, or click any tile to move.
Press "e" or click on the inventory icon in the top-left to open your inventory.`
        }
    },
    elarianShop: {
        lockedCellar: {
            text: "The cellar is locked."
        }
    },
    elarianTower: {
        faint: {
            text: `Everything goes black... You slowly regain consciousness.`,
            nextFunction: ()=>{
                if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("wizardEldwin.firstFaint")) return "wizardEldwin.firstFaint";
                else return "wizardEldwin.faint";
            }
        }
    },
    elarianCourtyard: {
        investigateDragonStatue: {
            text: `The text on the statue reads: "Here lies the great dragon, protector of Glenfall. May his spirit forever watch over us."
      It looks like the statue has a small slit near the base, just big enough to fit your sword...`,
            includeClose: true,
            options: [
                {
                    display: "Put your sword in the slit",
                    next: "elarianCourtyard.statueActions"
                }
            ]
        },
        ...(0, $a02de5696100d47d$export$d4e22b55fa08e445)("elarianCourtyard")
    }
};







const $7e13fb4c196fb7eb$var$returnOption = [
    {
        display: "Return to map",
        function: ()=>(0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).returnToMap()
    }
];
const $7e13fb4c196fb7eb$var$forestTreasure = (locationName, x, y)=>({
        text: "You found 100 gold.",
        function: ()=>{
            (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateGold(100);
            (0, $846df9480552348c$export$17b07c660794dc13).addModifiedTile(locationName, {
                type: "path",
                x: x,
                y: y,
                tileImage: null,
                dialogueFunction: null,
                displayFunction: null,
                noMovement: null
            });
            (0, $846df9480552348c$export$17b07c660794dc13).displayLocation(locationName);
        }
    });
const $7e13fb4c196fb7eb$export$1afdd3c723fe85eb = {
    goblinForest: {
        combat: {
            text: "What will you do?",
            manualOptions: true,
            function: ()=>{
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons((0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).getAttackOptions());
            }
        },
        items: {
            text: "What will you use?",
            manualOptions: true,
            function: ()=>{
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons([
                    ...(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.filter((item)=>item.type === "combatItem").map((item)=>({
                            display: `Use ${item.name.toLowerCase()}${item.uses ? ` (${item.uses} use${item.uses > 1 ? "s" : ""} remaining)` : ""}`,
                            next: item.useDialogue
                        })),
                    {
                        display: "Nevermind",
                        next: "goblinForest.combat"
                    }
                ]);
            }
        },
        firstGoblet: {
            text: "A goblet appears! Goblets are miniture goblins that they keep as pets.",
            next: "goblinForest.combat"
        },
        firstDefeatGoblet: {
            text: 'You defeated the goblet. They say, "There are no bad goblets, only bad owners."',
            options: $7e13fb4c196fb7eb$var$returnOption
        },
        goblet: {
            textFunction: ()=>{
                const textOptions = [
                    "A goblet appears! It looks like it is trying to be sneaky.",
                    "A goblet jumps out from behind a tree! It looks pretty cute, but it is still dangerous.",
                    "A goblet is blocking your path! Well, I guess you could walk around it, but it might bite you."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            next: "goblinForest.combat"
        },
        defeatGoblet: {
            textFunction: ()=>{
                const textOptions = [
                    "The goblet falls to the ground. He was probably a good boy.",
                    "You defeated the goblet. Maybe they wanted to be a goblin when they grew up?",
                    "You defeated the goblet. It was probably just following orders."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            options: $7e13fb4c196fb7eb$var$returnOption
        },
        firstGoblin: {
            text: "A goblin appears! These ruthless minions of the Goblin King are responsible for thefts and attacks in the forest.",
            next: "goblinForest.combat"
        },
        firstDefeatGoblin: {
            text: "You defeated the goblin. Is it okay to take its gold if it is stolen? You decide to take it anyway.",
            options: $7e13fb4c196fb7eb$var$returnOption
        },
        goblin: {
            textFunction: ()=>{
                const textOptions = [
                    "A goblin appears! I wonder how long they have been watching you...",
                    "A goblin jumps out from behind a tree! They seem to be getting more aggressive.",
                    "A goblin is blocking your path! How many of them are there?"
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            next: "goblinForest.combat"
        },
        defeatGoblin: {
            textFunction: ()=>{
                const textOptions = [
                    "The goblin falls to the ground. It looks like it was just a kid. Maybe they are forced to do this?",
                    "You defeated the goblin. It had some gold in its backpack.",
                    "You defeated the goblin. Hopefully it learned its lesson."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            options: $7e13fb4c196fb7eb$var$returnOption
        },
        firstOgre: {
            text: "An ogre appears! A meaty creature that isn't too bright, but it is very strong. Hopefully you can defeat it...",
            next: "goblinForest.combat"
        },
        firstDefeatOgre: {
            text: "You defeated the ogre. If he wasn't working for the Goblin King, he probably would have been friendly.",
            options: $7e13fb4c196fb7eb$var$returnOption
        },
        ogre: {
            textFunction: ()=>{
                const textOptions = [
                    "An ogre appears! He gives you an angry look and clenches his fist around his club.",
                    "An ogre jumps out from behind a tree! He looks like he is ready to fight.",
                    "An ogre is blocking your path! Maybe you could sneak between his legs? No, that wouldn't work."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            next: "goblinForest.combat"
        },
        defeatOgre: {
            textFunction: ()=>{
                const textOptions = [
                    "The ogre falls to the ground. At least he won't be causing any more trouble.",
                    "You defeated the ogre. I hope he was the last one in the forest.",
                    "You defeated the ogre. He probably would have been a good friend if he was not so angry."
                ];
                return textOptions[Math.floor(Math.random() * textOptions.length)];
            },
            options: $7e13fb4c196fb7eb$var$returnOption
        },
        ogreSpray: {
            textFunction: ()=>{
                if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy?.name !== "ogre") return "You cannot use the ogre spray on this enemy. What will you do?";
                const ogreSpray = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.find((item)=>item.name === "Ogre Spray");
                ogreSpray.uses -= 1;
                if (ogreSpray.uses === 0) // Remove the ogre spray that was used up.
                (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.filter((item)=>item.uses !== 0);
                return "You used the ogre spray. The ogre ran away! Hopefully he will not come back...";
            },
            manualOptions: true,
            function: ()=>{
                if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentEnemy.name === "ogre") (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons($7e13fb4c196fb7eb$var$returnOption);
                else (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons((0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).getAttackOptions());
            }
        },
        smallHealthPotion: {
            textFunction: ()=>{
                const smallHealthPotion = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.find((item)=>item.name === "Small Health Potion");
                if (!smallHealthPotion) return "You do not have a small health potion. What will you do?";
                smallHealthPotion.uses -= 1;
                (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.filter((item)=>item.uses !== 0);
                const oldHp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp;
                (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp = Math.min((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp + 50, (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp);
                const newHp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp;
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateHealthBar();
                return `You used the small health potion. You gained ${newHp - oldHp} health points!`;
            },
            manualOptions: true,
            function: ()=>{
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons((0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).getAttackOptions());
            }
        },
        smallMagicPotion: {
            textFunction: ()=>{
                const smallMagicPotion = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.find((item)=>item.name === "Small Magic Potion");
                if (!smallMagicPotion) return "You do not have a small magic potion. What will you do?";
                smallMagicPotion.uses -= 1;
                (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.filter((item)=>item.uses !== 0);
                const oldMp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp;
                (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp = Math.min((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp + 9, (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp);
                const newMp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp;
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateMagicBar();
                return `You used the small magic potion. You gained ${newMp - oldMp} magic points!`;
            },
            manualOptions: true,
            function: ()=>{
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons((0, $d9775c0412d7d5fd$export$d1fc4b468dcebbc2).getAttackOptions());
            }
        },
        treasureRight1: $7e13fb4c196fb7eb$var$forestTreasure("goblinForestRight2", 7, 2),
        treasureRight2: $7e13fb4c196fb7eb$var$forestTreasure("goblinForestRight2", 7, 5)
    }
};



const $dc3c719ddf658c20$export$952fc68897a3f784 = {
    mirewoodCourtyard: {
        investigateBasiliskStatue: {
            text: 'The text on the statue reads: "The basilisk used to prowl the swamps of Mirewood, turning all who looked into its eyes to stone until he looked at his reflection and turned himself to stone."This statue also has a small slit for your sword...',
            includeClose: true,
            options: [
                {
                    display: "Put your sword in the slit",
                    next: "mirewoodCourtyard.statueActions"
                }
            ]
        },
        ...(0, $a02de5696100d47d$export$d4e22b55fa08e445)("mirewoodCourtyard")
    }
};


const $e0d074ef63806a25$export$230e16c314b11725 = {
    ...(0, $6fc86d4595310317$export$5f261e47b4e31f76),
    ...(0, $7e13fb4c196fb7eb$export$1afdd3c723fe85eb),
    ...(0, $dc3c719ddf658c20$export$952fc68897a3f784)
};


const $90e798d65db8ae70$export$230e16c314b11725 = {
    ...(0, $e0d074ef63806a25$export$230e16c314b11725),
    ...(0, $bc4efe90a4dcd3ee$export$51aacac15ce329c4).dialogues
};
const $90e798d65db8ae70$var$writeText = async (text, textElementId, npcName)=>{
    // Clear option buttons when writing text.
    $90e798d65db8ae70$var$createOptionButtons();
    const characterElement = document.getElementById("characterDisplay");
    const textWrapper = document.getElementById("textDisplayWrapper");
    const textElement = document.getElementById(textElementId || "textDisplay");
    if (textElementId) textElement.style.display = "flex";
    textElement.innerHTML = "";
    if (npcName) {
        let thisImage = "";
        let thisName = "";
        if (npcName !== "Thaddeus") {
            const thisNpc = (0, $bc4efe90a4dcd3ee$export$51aacac15ce329c4).npcList.find((n)=>n.name === npcName);
            thisImage = (0, $846df9480552348c$export$17b07c660794dc13).images.npc[thisNpc.tileImage];
            thisName = thisNpc.displayName || thisNpc.name;
        } else {
            thisImage = (0, $846df9480552348c$export$17b07c660794dc13).images.thaddeus;
            thisName = "Thaddeus";
        }
        const imageElement = document.createElement("img");
        imageElement.draggable = false;
        imageElement.src = thisImage;
        imageElement.id = "characterImageDisplay";
        const name = thisName;
        const nameElement = document.createElement("div");
        nameElement.id = "characterNameDisplay";
        nameElement.textContent = name;
        characterElement.innerHTML = "";
        characterElement.appendChild(imageElement);
        textElement.appendChild(nameElement);
        characterElement.style.display = "block";
    } else {
        characterElement.innerHTML = "";
        characterElement.style.display = "none";
    }
    if (!text) {
        textWrapper.style.display = "none";
        return textElement.style.display = "none";
    } else {
        textWrapper.style.display = "flex";
        textElement.style.display = "flex";
    }
    textElement.innerHTML += "<p></p>";
    const pElement = textElement.lastChild;
    for (const char of text){
        await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).delay(22);
        pElement.textContent += char;
        // Automatically scroll to the bottom of the text display.
        pElement.scrollTop = pElement.scrollHeight;
    }
};
// Display a list of options as buttons on the screen. If no options are provided, the screen will be cleared.
const $90e798d65db8ae70$var$createOptionButtons = (options, optionElementId)=>{
    const optionElement = document.getElementById(optionElementId || "optionDisplay");
    optionElement.innerHTML = "";
    if (options?.length) optionElement.style.display = "flex";
    else return optionElement.style.display = "none";
    options?.forEach((option)=>{
        const button = document.createElement("div");
        button.classList.add("option");
        button.innerHTML = `<div class="text-with-padding">${option.display}</div>`;
        button.onclick = ()=>{
            option.function?.();
            if (option.text) $90e798d65db8ae70$var$displayDialogue({
                thisDialogue: option
            });
            else if (option.next) $90e798d65db8ae70$var$displayDialogue({
                dialogueName: option.next
            });
            else if (option.nextFunction) $90e798d65db8ae70$var$displayDialogue({
                dialogueName: option.nextFunction()
            });
        };
        optionElement.appendChild(button);
    });
    // Automatically scroll to the top of the option display.
    optionElement.scrollTop = 0;
};
const $90e798d65db8ae70$var$displayDialogue = async ({ dialogueName: dialogueName, thisDialogue: thisDialogue, enemyDefeated: enemyDefeated })=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).canExitDialogue = false;
    if (!thisDialogue && dialogueName) thisDialogue = $90e798d65db8ae70$export$c47cc8aa20293d7d(dialogueName);
    if (thisDialogue) {
        let npcName = "";
        if (dialogueName) npcName = (0, $bc4efe90a4dcd3ee$export$51aacac15ce329c4).npcList.find((n)=>n.dialogueKey === dialogueName.split(".")[0])?.name;
        else npcName = "Thaddeus";
        await thisDialogue.prefunction?.();
        const text = thisDialogue.textFunction?.() || thisDialogue.text;
        await $90e798d65db8ae70$var$writeText(text, undefined, npcName || undefined);
        // Set the dialogue as seen before running the function so that when the game is saved, the dialogue is saved as seen.
        if (dialogueName) $90e798d65db8ae70$var$setDialogueSeen(dialogueName);
        await thisDialogue.function?.();
        if (enemyDefeated) {
            const bossMultiplier = enemyDefeated.boss ? 1.5 : 1;
            const experience = Math.max(Math.floor(enemyDefeated.level * enemyDefeated.level * bossMultiplier), 2);
            (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).experience += experience;
            await $90e798d65db8ae70$var$waitForContinue();
            await $90e798d65db8ae70$var$writeText(`You found ${enemyDefeated.gold} gold and gained ${experience} experience.`);
            (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateGold(enemyDefeated.gold);
            await (0, $504c2f61098a857b$export$7debb50ef11d5e0b).updateExperienceBar();
        }
        if (thisDialogue.nextFunction) thisDialogue.next = thisDialogue.nextFunction();
        const filteredOptions = thisDialogue.options?.filter((option)=>$90e798d65db8ae70$var$checkRequirements(option.requires));
        if (thisDialogue.includeClose) filteredOptions.push({
            display: "Close",
            function: $90e798d65db8ae70$var$clearScreen
        });
        if (filteredOptions?.length) $90e798d65db8ae70$var$createOptionButtons(filteredOptions);
        else if (thisDialogue.next || thisDialogue.continueFunction) $90e798d65db8ae70$var$createOptionButtons([
            {
                display: "Continue",
                function: async ()=>{
                    await thisDialogue.continueFunction?.();
                    if (thisDialogue.next) $90e798d65db8ae70$var$displayDialogue({
                        dialogueName: thisDialogue.next
                    });
                }
            }
        ]);
        else if (!thisDialogue.manualOptions) $90e798d65db8ae70$var$createOptionButtons([
            {
                display: "Close",
                function: $90e798d65db8ae70$var$clearScreen
            }
        ]);
    }
};
const $90e798d65db8ae70$var$waitForContinue = async ()=>new Promise((resolve)=>$90e798d65db8ae70$var$createOptionButtons([
            {
                display: "Continue",
                function: resolve
            }
        ]));
const $90e798d65db8ae70$export$c47cc8aa20293d7d = (dialogueName)=>{
    let thisDialogue;
    const dialogueObject = dialogueName.split(".")[0];
    const dialogueKeys = dialogueName.split(".").slice(1);
    thisDialogue = $90e798d65db8ae70$export$230e16c314b11725[dialogueObject];
    dialogueKeys.forEach((key)=>{
        thisDialogue = thisDialogue?.[key];
    });
    // If no dialogue found, then close the text display so the player can continue playing.
    if (!thisDialogue) {
        console.error(`Dialogue not found: ${dialogueName}`);
        return $90e798d65db8ae70$var$clearScreen();
    }
    return thisDialogue;
};
const $90e798d65db8ae70$var$clearScreen = ()=>{
    $90e798d65db8ae70$var$writeText();
    $90e798d65db8ae70$var$createOptionButtons();
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).canExitDialogue = true;
    (0, $846df9480552348c$export$17b07c660794dc13).checkNearbyInteraction();
};
const $90e798d65db8ae70$var$checkDialogue = (dialogueName)=>{
    const dialogueObject = dialogueName.split(".")[0];
    const dialogueKey = dialogueName.split(".").slice(1).join(".");
    return (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).dialogue[dialogueObject]?.[dialogueKey];
};
const $90e798d65db8ae70$var$setDialogueSeen = (dialogueName)=>{
    const dialogueObject = dialogueName.split(".")[0];
    const dialogueKey = dialogueName.split(".").slice(1).join(".");
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).dialogue[dialogueObject] = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).dialogue[dialogueObject] || {};
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).dialogue[dialogueObject][dialogueKey] = true;
};
const $90e798d65db8ae70$var$checkRequirements = (requirements)=>{
    if (!requirements) return true;
    if (requirements.and) return requirements.and.every((cond)=>$90e798d65db8ae70$var$evaluateCondition(cond));
    if (requirements.or) return requirements.or.some((cond)=>$90e798d65db8ae70$var$evaluateCondition(cond));
    return $90e798d65db8ae70$var$evaluateCondition(requirements);
};
const $90e798d65db8ae70$var$evaluateCondition = (condition)=>{
    if (condition.inventory) return (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.find((item)=>item.name === condition.inventory);
    if (condition.not) return !$90e798d65db8ae70$export$f1d985ef2ac6d781.checkDialogue(condition.not);
    if (condition.check) return $90e798d65db8ae70$export$f1d985ef2ac6d781.checkDialogue(condition.check);
    if (condition.and || condition.or) return $90e798d65db8ae70$var$checkRequirements(condition);
    return false;
};
const $90e798d65db8ae70$export$f1d985ef2ac6d781 = {
    writeText: $90e798d65db8ae70$var$writeText,
    createOptionButtons: $90e798d65db8ae70$var$createOptionButtons,
    displayDialogue: $90e798d65db8ae70$var$displayDialogue,
    checkDialogue: $90e798d65db8ae70$var$checkDialogue,
    setDialogueSeen: $90e798d65db8ae70$var$setDialogueSeen,
    clearScreen: $90e798d65db8ae70$var$clearScreen,
    waitForContinue: $90e798d65db8ae70$var$waitForContinue
};



let $504c2f61098a857b$var$experienceTable = {};
for(let i = 1; i <= 100; i++){
    let thisLevel = i;
    // n^3 - 1 is the experience formula in Glenfall. n^3 is the formula used for medium fast leveling in Pokemon.
    $504c2f61098a857b$var$experienceTable[thisLevel] = thisLevel * thisLevel * thisLevel - 1;
}
const $504c2f61098a857b$var$updateHealthBar = async (healthBarId, hp, maxHp)=>{
    const hpDisplayId = healthBarId === "enemyHealthLevel" ? "enemyHpDisplay" : "hpDisplay";
    if (typeof hp !== "number") hp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp;
    if (typeof maxHp !== "number") maxHp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp;
    document.getElementById(hpDisplayId).innerHTML = `${hp}/${maxHp}`;
    const healthBar = document.getElementById(healthBarId || "healthLevel");
    let percentage = hp / maxHp * 100;
    if (percentage < 0) percentage = 0;
    healthBar.style.width = percentage + "%";
    if (percentage > 60) healthBar.style.backgroundColor = "#228b22";
    else if (percentage > 30) healthBar.style.backgroundColor = "#CCAA00";
    else healthBar.style.backgroundColor = "#AB0000";
};
const $504c2f61098a857b$var$updateExperienceBar = async ()=>{
    const experienceBar = document.getElementById("experienceLevel");
    const xpToNextLevel = $504c2f61098a857b$var$experienceTable[(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level + 1] - $504c2f61098a857b$var$experienceTable[(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level];
    let percentage = ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).experience - $504c2f61098a857b$var$experienceTable[(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level]) / xpToNextLevel * 100;
    if (percentage < 0) percentage = 0;
    if (percentage > 100) percentage = 100;
    experienceBar.style.width = percentage + "%";
    // Wait for the experience bar to finish filling before continuing.
    await $504c2f61098a857b$var$delay(1000);
    if (percentage == 100) await $504c2f61098a857b$var$levelUp();
};
const $504c2f61098a857b$var$levelUp = async ()=>{
    const experienceBar = document.getElementById("experienceLevel");
    experienceBar.style.width = 0;
    await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText(`Congratulations! You have reached level ${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level + 1}!`);
    // A little extra delay so the experience bar can finish resetting.
    await $504c2f61098a857b$var$delay(100);
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level++;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).skillPoints++;
    // The stat increases are arbitrary and can be adjusted as needed.
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp += 4;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp;
    if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level % 2 === 1) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp += 1;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp;
    $504c2f61098a857b$var$updateMagicBar();
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).attack += 2;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).magicAttack += 2;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).defense += 2;
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).magicDefense += 2;
    $504c2f61098a857b$var$updateHealthBar();
    await $504c2f61098a857b$var$updateExperienceBar();
};
const $504c2f61098a857b$var$updateMagicBar = ()=>{
    document.getElementById("mpDisplay").innerHTML = `${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp}/${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp}`;
    const magicBar = document.getElementById("magicLevel");
    let percentage = (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp / (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp * 100;
    if (percentage < 0) percentage = 0;
    magicBar.style.width = percentage + "%";
};
const $504c2f61098a857b$var$updateGold = (amount)=>{
    if (amount) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).gold += amount;
};
const $504c2f61098a857b$var$loadSave = async (slot)=>{
    slot = slot || 0;
    const saves = JSON.parse(localStorage.getItem("save"));
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).saveId = slot;
    if (saves?.length && saves[slot]) {
        for(const key in 0, $bd94a79bfb1fb5b4$export$615455393ee443ca)if (Object.prototype.hasOwnProperty.call(saves[slot], key)) (0, $bd94a79bfb1fb5b4$export$615455393ee443ca)[key] = saves[slot][key];
    }
    if (!(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hideHealth) $504c2f61098a857b$var$revealHealthAndXp();
    if (!(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hideMagic) $504c2f61098a857b$var$revealMagic();
    if (!(0, $90e798d65db8ae70$export$f1d985ef2ac6d781).checkDialogue("elarianGates.intro")) (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
        dialogueName: "elarianGates.intro"
    });
    else (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).clearScreen();
    // Display location second because the location might contain dialogue.
    (0, $846df9480552348c$export$17b07c660794dc13).displayLocation((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).currentLocation);
    if ((0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp > 0) (0, $846df9480552348c$export$17b07c660794dc13).showDisplay();
};
// The goal is to save the game every time the player object is updated.
const $504c2f61098a857b$var$saveGame = ()=>{
    const save = JSON.parse(localStorage.getItem("save"));
    let saveFiles = save?.length ? save : [];
    if (saveFiles.length) saveFiles = saveFiles.map((save, index)=>index === (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).saveId ? {
            ...(0, $bd94a79bfb1fb5b4$export$615455393ee443ca)
        } : save);
    else saveFiles = [
        {
            ...(0, $bd94a79bfb1fb5b4$export$615455393ee443ca)
        }
    ];
    localStorage.setItem("save", JSON.stringify(saveFiles));
};
// Health and magic are revealing during the tutorial.
const $504c2f61098a857b$var$revealHealthAndXp = ()=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hideHealth = false;
    document.getElementById("hpDisplay").innerHTML = `${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hp}/${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxHp}`;
    document.getElementById("healthAndXpContainer").style.display = "flex";
    $504c2f61098a857b$var$updateHealthBar();
    $504c2f61098a857b$var$updateExperienceBar();
};
const $504c2f61098a857b$var$revealMagic = ()=>{
    (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).hideMagic = false;
    document.getElementById("mpDisplay").innerHTML = `${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).mp}/${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).maxMp}`;
    document.getElementById("magicContainer").style.display = "flex";
    $504c2f61098a857b$var$updateMagicBar();
};
const $504c2f61098a857b$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $504c2f61098a857b$export$7debb50ef11d5e0b = {
    updateHealthBar: $504c2f61098a857b$var$updateHealthBar,
    updateMagicBar: $504c2f61098a857b$var$updateMagicBar,
    updateExperienceBar: $504c2f61098a857b$var$updateExperienceBar,
    updateGold: $504c2f61098a857b$var$updateGold,
    loadSave: $504c2f61098a857b$var$loadSave,
    saveGame: $504c2f61098a857b$var$saveGame,
    revealHealthAndXp: $504c2f61098a857b$var$revealHealthAndXp,
    revealMagic: $504c2f61098a857b$var$revealMagic,
    delay: $504c2f61098a857b$var$delay
};






var $74a7638adf6a1a5d$exports = {};
$74a7638adf6a1a5d$exports = new URL("crown.5a3798ea.webp", import.meta.url).toString();


var $bac4c5f64b8b7383$exports = {};
$bac4c5f64b8b7383$exports = new URL("ogre-spray.756de276.webp", import.meta.url).toString();


var $68cef3b4306dd97c$exports = {};
$68cef3b4306dd97c$exports = new URL("small-magic-potion.97cd17a4.webp", import.meta.url).toString();


var $14627ef815e27841$exports = {};
$14627ef815e27841$exports = new URL("small-health-potion.bffb3fcc.webp", import.meta.url).toString();


const $0728a79f19f209ae$export$17a1664ed1fb5d6f = [
    {
        name: "King's Crown",
        type: "questItem",
        image: new URL($74a7638adf6a1a5d$exports)
    },
    {
        name: "Ogre Spray",
        type: "combatItem",
        uses: 3,
        useDialogue: "goblinForest.ogreSpray",
        image: new URL($bac4c5f64b8b7383$exports)
    },
    {
        name: "Small Magic Potion",
        type: "combatItem",
        uses: 1,
        useDialogue: "goblinForest.smallMagicPotion",
        image: new URL($68cef3b4306dd97c$exports)
    },
    {
        name: "Small Health Potion",
        type: "combatItem",
        uses: 1,
        useDialogue: "goblinForest.smallHealthPotion",
        image: new URL($14627ef815e27841$exports)
    }
];



let $64c809f18dca20e5$var$inventoryOpen = false;
const $64c809f18dca20e5$var$closeInventoryClickListener = (e)=>{
    if (e.target.id !== "inventoryModalContent" && e.target.id !== "inventoryIcon") $64c809f18dca20e5$var$closeInventory();
};
var $a02ddfb20ae0913a$exports = {};
$a02ddfb20ae0913a$exports = new URL("gold-coin.dabc275c.webp", import.meta.url).toString();



const $64c809f18dca20e5$var$openInventory = ()=>{
    $64c809f18dca20e5$var$inventoryOpen = true;
    document.body.insertAdjacentHTML("beforeend", /*html*/ `
    <div id="inventoryModalShadow"></div>
    <div id="inventoryModalContent">
    <div class="inventory-section" id="itemsSection">
      <div class="inventory-header" id="goldSection">
        <img src="${new URL($a02ddfb20ae0913a$exports)}" alt="Gold" class="gold-icon" title="gold" draggable="false">
        <div>${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).gold}</div>
      </div>
      <div class="inventory-header">Items</div>
      <div class="inventory-items">
        ${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).inventory.map((item)=>{
        const image = (0, $0728a79f19f209ae$export$17a1664ed1fb5d6f).find((i)=>i.name === item.name).image;
        return /*html*/ `
              <div class="inventory-item">
                <img src="${image}" alt="${item.name}" class="inventory-item-image" title="${item.name}" draggable="false">
                <div>${item.name}</div>
              </div>
            `;
    }).join("")}
      </div>
    </div>
    <div class="inventory-section" id="equipmentSection">
      <div class="close-inventory" id="closeInventory">Close</div>
      <div class="inventory-header">
        <div>Level ${(0, $bd94a79bfb1fb5b4$export$615455393ee443ca).level}</div>
      </div>
      <img src="${new URL($a888fd8264d71d43$exports)}" alt="Thaddeus" class="inventory-thaddeus-image" draggable="false">   
      </div>   
    </div>
  `);
    document.getElementById("inventoryModalShadow")?.addEventListener("click", $64c809f18dca20e5$var$closeInventoryClickListener);
    document.getElementById("closeInventory")?.addEventListener("click", $64c809f18dca20e5$var$closeInventory);
};
const $64c809f18dca20e5$var$closeInventory = ()=>{
    document.getElementById("inventoryModalContent")?.remove();
    document.getElementById("inventoryModalShadow")?.remove();
    $64c809f18dca20e5$var$inventoryOpen = false;
};
const $64c809f18dca20e5$var$toggleInventory = ()=>{
    if ($64c809f18dca20e5$var$inventoryOpen) $64c809f18dca20e5$var$closeInventory();
    else $64c809f18dca20e5$var$openInventory();
};
const $64c809f18dca20e5$export$7332632509b42db4 = ()=>{
    const inventoryIcon = document.getElementById("inventoryIcon");
    inventoryIcon.addEventListener("click", $64c809f18dca20e5$var$toggleInventory);
    document.addEventListener("keydown", (e)=>{
        if (e.key === "e") $64c809f18dca20e5$var$toggleInventory();
    });
};


window.onload = async ()=>{
    $8f6a480bb40b134f$var$mainMenu();
    (0, $846df9480552348c$export$17b07c660794dc13).setupMovementListener();
    (0, $64c809f18dca20e5$export$7332632509b42db4)();
};
const $8f6a480bb40b134f$var$mainMenu = ()=>{
    const saves = JSON.parse(localStorage.getItem("save"));
    document.getElementById("menuTextDisplay").style.display = "none";
    if (saves?.length && saves[0].version && saves[0].version == (0, $bd94a79bfb1fb5b4$export$615455393ee443ca).version) (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons([
        {
            display: "Continue",
            function: ()=>{
                $8f6a480bb40b134f$var$showGame();
                (0, $504c2f61098a857b$export$7debb50ef11d5e0b).loadSave();
            }
        },
        {
            display: "New Game",
            function: ()=>{
                $8f6a480bb40b134f$var$confirmReset();
            }
        }
    ], "menuOptionDisplay");
    else (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons([
        {
            display: "New Game",
            function: ()=>{
                $8f6a480bb40b134f$var$showGame();
                (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("elarianGates");
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
                    dialogueName: "elarianGates.intro"
                });
            }
        }
    ], "menuOptionDisplay");
};
const $8f6a480bb40b134f$var$confirmReset = async ()=>{
    (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons([], "menuOptionDisplay");
    await (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).writeText("Are you sure you want to reset your game?", "menuTextDisplay");
    (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).createOptionButtons([
        {
            display: "Yes",
            function: ()=>{
                localStorage.removeItem("save");
                $8f6a480bb40b134f$var$showGame();
                (0, $846df9480552348c$export$17b07c660794dc13).displayLocation("elarianGates");
                (0, $90e798d65db8ae70$export$f1d985ef2ac6d781).displayDialogue({
                    dialogueName: "elarianGates.intro"
                });
            }
        },
        {
            display: "No",
            function: ()=>{
                $8f6a480bb40b134f$var$mainMenu();
            }
        }
    ], "menuOptionDisplay");
};
const $8f6a480bb40b134f$var$showGame = ()=>{
    document.getElementById("menu").style.display = "none";
    const gameDisplay = document.getElementById("game");
    gameDisplay.style.display = "flex";
};


//# sourceMappingURL=index.718c697b.js.map
